{
  "recruiting": "Reclutamento",
  "courses": "Corsi",
  "courses-page": {
    "title": "Corsi",
    "create": "Crea corso",
    "edit": "Modifica corso",
    "empty": "Nessun corso ancora",
    "fields": {
      "title": "Titolo",
      "description": "Descrizione",
      "documents-count": "Documenti"
    },
    "headers": {
      "title": "Titolo",
      "description": "Descrizione",
      "documents": "Documenti",
      "actions": "Azioni"
    },
    "dialog": {
      "title-label": "Titolo",
      "description-label": "Descrizione",
      "documents-label": "Documenti",
      "documents-placeholder": "Seleziona documenti della knowledge base",
      "save": "Salva",
      "cancel": "Annulla"
    },
    "messages": {
      "created": "Corso creato",
      "updated": "Corso aggiornato",
      "deleted": "Corso eliminato",
      "error": "Qualcosa è andato storto"
    },
    "confirm-delete": "Eliminare questo corso? L'operazione non può essere annullata."
  },
  "ai-study-chat": "Chat di studio AI",
  "ai-study-chat-page": {
    "title": "Chat di studio AI",
    "new-conversation": "Nuova conversazione",
    "empty-sidebar": "Nessuna conversazione ancora",
    "empty-thread": "Scegli un corso o uno scenario per iniziare ad imparare",
    "untitled": "Nuova chat",
    "input-placeholder": "Scrivi la tua domanda…",
    "send": "Invia",
    "typing": "L'assistente sta scrivendo…",
    "sources": "Fonti ({count})",
    "score": "rilevanza",
    "retry": "Riprova",
    "failed": "Invio fallito",
    "sources-label": "Fonti",
    "copy": "Copia",
    "copied": "Copiato",
    "search-placeholder": "Cerca conversazioni",
    "search-empty": "Nessun risultato trovato",
    "empty": {
      "heading": "Pronto ad aiutarti a imparare",
      "subtitle": "Chiedi qualsiasi cosa sui materiali del corso — troverò la risposta nella knowledge base e mostrerò le fonti."
    },
    "groups": {
      "today": "Oggi",
      "yesterday": "Ieri",
      "earlier": "Precedenti"
    },
    "composer": {
      "context": "Contesto:",
      "hint": "Le risposte sono generate dall'IA dai tuoi materiali · Invio per inviare, Shift+Invio per andare a capo"
    },
    "suggestions-fallback": [
      {
        "title": "Riassumi i materiali",
        "subtitle": "Punti chiave"
      },
      {
        "title": "Crea un piano di studio",
        "subtitle": "Da dove iniziare"
      },
      {
        "title": "Mettimi alla prova",
        "subtitle": "Verifica rapida"
      },
      {
        "title": "Spiega in modo semplice",
        "subtitle": "Senza tecnicismi"
      }
    ],
    "suggestions-fallback-debrief": [
      { "title": "Analizza questa sessione", "subtitle": "Punti chiave" },
      { "title": "Cosa ho fatto bene?", "subtitle": "I miei punti di forza" },
      { "title": "Dove ho sbagliato e perché?", "subtitle": "Aree di crescita" },
      { "title": "Cosa devo migliorare nella prossima sessione?", "subtitle": "Passi concreti" }
    ],
    "suggestions-fallback-progress": [
      { "title": "Come stanno evolvendo i miei risultati?", "subtitle": "Tra le sessioni" },
      { "title": "Le mie competenze forti e deboli", "subtitle": "Dai punteggi delle sessioni" },
      { "title": "Su cosa dovrei concentrarmi?", "subtitle": "Priorità di allenamento" },
      { "title": "Confronta la mia prima e ultima sessione", "subtitle": "Cosa è migliorato" }
    ],
    "quota": {
      "remaining": "{count} messaggi rimanenti",
      "exhausted": "Hai esaurito i messaggi della chat AI.",
      "unavailable": "La chat AI non è disponibile nel tuo piano."
    },
    "new-dialog": {
      "title": "Nuova conversazione",
      "subtitle": "Scegli la fonte da cui l'IA risponderà",
      "source-type": "Fonte",
      "source-course": "Corso",
      "source-scenario": "Scenario",
      "source-competency": "Competenza",
      "pick-course": "Scegli un corso",
      "pick-scenario": "Scegli uno scenario",
      "pick-competency": "Scegli una competenza",
      "pick-target": "Tutte le sessioni o una sessione specifica",
      "all-games": "Tutte le sessioni — il mio progresso",
      "all-games-sub": "Andamento dei punteggi per questa competenza",
      "back": "Indietro",
      "no-games": "Nessuna sessione completata",
      "empty-competencies": "Nessuna sessione completata per ora",
      "empty-competencies-hint": "Completa una sessione di uno scenario con competenza: qui apparirà l'analisi con l'IA",
      "empty-courses": "Nessun corso disponibile per ora",
      "empty-scenarios": "Nessuno scenario disponibile per ora",
      "tag-game": "Sessione",
      "search": "Cerca…",
      "search-empty": "Nessun risultato trovato",
      "start": "Inizia",
      "cancel": "Annulla"
    },
    "stage": {
      "searching": "Sto cercando nei tuoi materiali…",
      "reading": "Sto leggendo le fonti…",
      "writing": "Sto scrivendo la risposta…",
      "writing_sources": "Sto analizzando {count} frammenti…",
      "summarizing_short": "Organizzo il contesto precedente",
      "searching_short": "Cerco nei tuoi materiali",
      "reading_short": "Leggo le fonti",
      "writing_short": "Scrivo la risposta",
      "writing_sources_short": "Analizzo {count} frammenti"
    },
    "errors": {
      "send": "Impossibile inviare il messaggio. Riprova.",
      "quota": "Quota messaggi raggiunta.",
      "rate_limit": "Troppe richieste. Attendi un minuto e riprova.",
      "provider_unsupported": "La chat della knowledge base non è disponibile con l'attuale fornitore AI della tua organizzazione.",
      "generic": "Qualcosa è andato storto."
    }
  },
  "base_title": "La Riflessone",
  "base_title_ru": "SkillsTrainer",
  "404_title": "Pagina Non Trovata ⚠️",
  "404_description": "Non abbiamo trovato la pagina che stai cercando.",
  "404_home": "Torna alla Home",
  "401_title": "Non sei autorizzato! 🔐",
  "401_description": "Non hai il permesso per accedere a questa pagina. Torna alla Home!",
  "401_home": "Torna alla Home",
  "changes_saved": "Modifiche salvate",
  "coming_soon": "In arrivo",
  " ": " ",
  "select_date_and_time": "Seleziona data e ora",
  "select_date": "Seleziona data",
  "chat": "Chat",
  "menu": "Menù",
  "games": "Sessioni",
  "tours": "Tour della sessione",
  "library": "Biblioteca",
  "library-video": "Video",
  "library-scorm": "Corsi",
  "library-documents": "Documenti",
  "scenarios": "Scenario",
  "competencies": "Competenze",
  "competencies-list": "Elenco",
  "skills": "Abilità",
  "home": "Inizio",
  "home_player": "Partecipante",
  "player": "Partecipante",
  "home_expert": "Esperto",
  "reports-analytics-tours": "Tour della sessione",
  "reports": "Rapporti",
  "ranking": "Classifica",
  "analytics": "Analisi",
  "support": "Supporto",
  "users": "Utenti",
  "participants": "Partecipanti",
  "departments": "Dipartimento aziendale",
  "positions": "Rolo aziendale",
  "user-custom-fields": "Campi personalizzati",
  "administration": "Amministrazione",
  "ai-assistants": "Assistenti AI",
  "ai-profiles": "Profili AI",
  "ai-connectors": "Connettori AI",
  "Audit logs": "Registri di audit",
  "organizations": "Organizzazioni",
  "loading": "Caricamento...",
  "retry": "Riprova",
  "previous": "Precedente",
  "next": "Successivo",
  "save": "Salva",
  "copy": "Copia",
  "copy_failed": "Impossibile copiare automaticamente. Selezioni il testo nel campo e lo copi manualmente (Ctrl+C o ⌘C).",
  "confirm": "Conferma",
  "suggest": "Proporre",
  "generate": "Genera",
  "cancel": "Annulla",
  "close": "Chiudi",
  "search": "Cerca...",
  "accept": "Accetta",
  "propose": "Proponi",
  "decline": "Rifiuta",
  "send_request": "Invia richiesta",
  "assign": "Assegna",
  "actions": " ",
  "evaluators": {
    "ai": "AI",
    "expert": "Esperto",
    "player": "Partecipante",
    "manager": "Manager",
    "head": "Responsabile"
  },
  "statistics": {
    "date_from": "Da",
    "date_to": "A",
    "competence": "Competenza",
    "evaluator": "Valutatore",
    "last_games_effectiveness": {
      "effectiveness": "Efficacia",
      "title": "Efficacia delle Sessioni"
    },
    "skill_trend": {
      "average_score": "Punteggio Medio",
      "game": "Sessione",
      "score": "Punteggio",
      "title": "Punteggio Medio per Competenze"
    },
    "player_competence_radar": {
      "title": "Statisticha di Competenza",
      "top": "Top 10",
      "players_in_company": "Partecipanti nell'azienda",
      "by_games": "Analisi per sessioni",
      "subtitle": "Statisticha Generale per Te e la Tua Azienda",
      "filter": "Filtro",
      "you": "Tu",
      "company": "Azienda",
      "average_score": "punteggio medio",
      "skills_counted": "{counted} su {total} abilità"
    }
  },
  "participant": {
    "upcoming_games": "Sessioni in arrivo",
    "for_rank_games": "Scelga"
  },
  "roles": {
    "player": "Partecipante",
    "admin": "Superamministratore (sistema)",
    "scoped_admin": "Amministratore principale",
    "observer": "Osservatore",
    "captain": "Capitano",
    "expert": "Esperto",
    "lead_expert": "Esperto principale",
    "manager": "Manager",
    "support": "Supporto",
    "early_access": "Accesso anticipato",
    "head": "Responsabile",
    "candidate": "Candidato"
  },
  "user-status": {
    "active": "Attivo",
    "inactive": "Inattivo",
    "pending": "In sospeso"
  },
  "pagination": {
    "showing": "mostrando",
    "to": "a",
    "of": "di",
    "entries": "voci"
  },
  "validator": {
    "required": "Questo campo è obbligatorio",
    "library": "La dimensione del file deve essere inferiore a 500MB",
    "email": "Il campo Email deve essere un email valida",
    "password": "Il campo deve contenere almeno una maiuscola, minuscola, carattere speciale e cifra con minimi 8 caratteri",
    "confirm": "La conferma del campo Password non corrisponde",
    "at_least": "Il campo deve contenere almeno",
    "items": "elementi",
    "number": "Questo campo deve essere un numero intero",
    "is_odd": "Questo campo deve essere pari",
    "number_between": "Inserisci un numero tra",
    "number_and": "e",
    "date_range_required": "Intervallo richiesto",
    "invalid_date_range": "Intervallo non valido",
    "invalid_date_format": "Formato data non valido",
    "start_date_after_end_date": "La data di inizio deve essere precedente alla data di fine",
    "max_180_days": "Massimo 180 giorni"
  },
  "user": {
    "menu": {
      "settings": "Impostazioni",
      "statistics": "Statistiche",
      "logout": "Esci"
    }
  },
  "theme": {
    "system": "Sistema",
    "light": "Chiaro",
    "dark": "Scuro"
  },
  "error": {
    "default": "Spiacente, si è verificato un errore. I nostri specialisti sono già al corrente e lo risolveranno il prima possibile.",
    "unauthorized": "La tua sessione è scaduta.",
    "contact-support": "Spiacente, si è verificato un errore. Si prega di contattare il supporto tecnico",
    "forbidden": "Accesso negato"
  },
  "confirmation": {
    "sure": "Sei sicuro di voler eliminare la voce?",
    "sure_return_to_time_scheduling": "Sei sicuro di voler riportare la sessione alla fase di coordinamento dell’orario di inizio?",
    "sure_restore": "Are you sure you want to restore the entry?",
    "sure_mark_failed": "Segnare la partita come fallita ed eliminare definitivamente tutte le valutazioni e i protocolli dei partecipanti?",
    "success": "Successo!",
    "deleted": "Eliminato",
    "failed_marked": "Partita segnata come fallita",
    "restored": "Restored",
    "cancel": "Annullato",
    "yes": "Sì",
    "no": "No"
  },
  "dashboards": {
    "player": {
      "summary": {
        "welcome": "Ciao",
        "progress": "Il tuo progresso complessivo",
        "stats": {
          "minutes": "Minuti in sessione",
          "effectiveness": "Efficienza",
          "completed_games_count": "Sessioni concluse",
          "total_games_count": "Sessioni fatte"
        }
      },
      "cards": {
        "players_rating": {
          "title": "Classifica aziendale",
          "player": "Partecipante",
          "effectiveness": "Efficacia"
        }
      }
    },
    "head": {
      "my_stats": "Le mie statistiche",
      "subordinates": "I miei subordinati",
      "subordinate_stats": "Statistiche del subordinato",
      "select_subordinate": "Seleziona un subordinato per visualizzare le statistiche",
      "no_subordinates": "Nessun subordinato assegnato"
    }
  },
  "chat-page": {
    "last_game": "Ultima sessione",
    "chats": "Chat",
    "no-chats": "Nessuna chat trovata",
    "contacts": "Contatti",
    "choose": "Scegli contatto",
    "send": "Invia",
    "type": "Scrivi il tuo messaggio...",
    "no-contacts": "Nessun contatto trovato",
    "search": "Cerca...",
    "start_conversation": "Inizia conversazione",
    "start_connecting": "Inizia a connetterti con le persone selezionando uno dei contatti a sinistra"
  },
  "scenarios-page": {
    "title": "Titolo",
    "export-docx": "Export .docx",
    "copy_title": "Copia scenario",
    "generate_ai_title": "Genera scenario IA",
    "organization": "Azienda",
    "competence": "Competenza",
    "actions": " ",
    "add": "Aggiungi scenario",
    "ai-generate": "Generazione IA",
    "copy": "Copia scenario",
    "add_popup": "Aggiungi scenario",
    "delete": "Elimina scenario",
    "edit": "Modifica scenario",
    "edit_popup": "Modifica scenario",
    "industries": [
      "FMCG/Vendita al dettaglio",
      "Farmaceutico",
      "Banche e Fintech",
      "Hotel e Turismo",
      "Aziende IT/SaaS",
      "Ristorazione/HoReCa",
      "E-commerce/Marketplace",
      "Manifatturiero/Industria 4.0",
      "Logistica e T&L",
      "Telecomunicazioni",
      "Educazione/EdTech",
      "Industria chimica",
      "Software di gestione della supply chain",
      "Settore pubblico/Organizzazioni no-profit"
    ],
    "case_types": [
      "Leadership e People-Management",
      "Reclutamento e valutazione del personale",
      "Vendite e servizio clienti",
      "Negoziazioni e influenza",
      "Gestione dei conflitti",
      "Strategia ed esecuzione"
    ],
    "cases": [
      [
        "Definizione obiettivi SMART/OKR",
        "Dare feedback di sviluppo (SBI/COIN)",
        "Delegazione",
        "Coaching GROW",
        "Valutazione delle prestazioni",
        "Mentoring"
      ],
      [
        "Colloquio basato sulle competenze (CBI)",
        "Valutazione/Assessment center",
        "Sessione di onboarding"
      ],
      [
        "Vendita classica di prodotto/servizio",
        "Gestione delle obiezioni",
        "Upsell/Cross-sell",
        "Gestione dei reclami",
        "Vendita multi-canale"
      ],
      [
        "Negoziazioni aziendali interne su budget/risorse",
        "Contratto cliente/fornitore",
        "Negoziazioni di crisi"
      ],
      [
        "Conflitto interpersonale nel team",
        "Manager-subordinato",
        "Conflitto di valori/etica"
      ],
      [
        "Prioritizzazione del portafoglio progetti",
        "Gestione del cambiamento",
        "Analisi dei rischi"
      ]
    ],
    "formats": [
      "1-1",
      "Gruppi"
    ],
    "labels": {
      "industry": "Settore",
      "case_type": "Tipo di caso",
      "case": "Caso",
      "format": "Formato",
      "duration": "Durata (minuti)",
      "game_vs_ai": "Sessione contro IA",
      "level": "Livello",
      "competence": "Competenza",
      "description": "Descrizione dello scenario",
      "description_hint": "Descrivi facoltativamente lo scenario che desideri generare (max 4000 caratteri)"
    },
    "generating_in_progress": "Generazione dello scenario in corso, attendere..."
  },
  "analytics-page": {
    "tours-page": {
      "tour": "Tour",
      "full_name": "Partecipante",
      "games_count": "Sessioni",
      "team": "Squadra",
      "export": "Esporta",
      "effectiveness": "Efficacia"
    }
  },
  "report-filters": {
    "department": "Dipartimento",
    "position": "Posizione",
    "employee": "Dipendente",
    "scenario": "Scenario",
    "competence": "Competenza",
    "period": "Periodo",
    "reset": "Reimposta",
    "only-period-competence": "Vengono applicati solo i filtri periodo e competenza"
  },
  "competencies-page": {
    "title": "Titolo",
    "export-docx": "Export .docx",
    "skills": "Abilità",
    "text": "Testo",
    "display_order": "Ordinamento",
    "ai-assistant": "Assistente AI",
    "language": "Lingua",
    "department": "Dipartimento",
    "actions": " ",
    "add": "Aggiungi competenza",
    "add_popup": "Aggiungi competenza",
    "delete": "Elimina competenza",
    "edit": "Modifica competenza",
    "edit_popup": "Modifica competenza"
  },
  "faq-page": {
    "title": "Domande",
    "question": "Domanda",
    "text": "Risposta",
    "is_shared": "Disponibile per tutte le aziende",
    "actions": " ",
    "visibility": "Visibilità",
    "visible_to_all": "Visibile a tutti gli utenti",
    "visible_to_managers": "Visibile solo ai manager",
    "add": "Aggiungi domanda",
    "add_popup": "Aggiungi domanda",
    "delete": "Elimina domanda",
    "edit": "Modifica domanda",
    "edit_popup": "Modifica domanda"
  },
  "ai-connectors-page": {
    "title": "Connettori AI",
    "is_shared": "Disponibile per tutte le organizzazioni",
    "actions": " ",
    "add": "Aggiungi connettore",
    "add_popup": "Aggiungi connettore",
    "delete": "Elimina connettore",
    "edit": "Modifica connettore",
    "edit_popup": "Modifica connettore",
    "label": "Etichetta",
    "provider": "Fornitore",
    "service": "Servizio",
    "organization": "Organizzazione",
    "status": "Stato",
    "region": "Regione",
    "endpoint": "Endpoint",
    "secret": "Password/Chiave",
    "maxConcurrency": "Concorrenza massima",
    "timeoutSec": "Timeout",
    "sortOrder": "Ordine",
    "config": "Configurazione",
    "modelPrimary": "Modello primary",
    "modelLight": "Modello light",
    "modelLightHint": "Se vuoto, le chiamate light usano il modello primary",
    "folderId": "ID folder",
    "models": "Modelli",
    "is_default": "Default",
    "notes": "Note"
  },
  "skills-page": {
    "title": "Titolo",
    "display_order": "Ordinamento",
    "competence": "Competenza",
    "text": "Indicatori",
    "actions": " ",
    "add": "Aggiungi abilità",
    "add_popup": "Aggiungi abilità",
    "delete": "Elimina abilità",
    "edit": "Modifica abilità",
    "edit_popup": "Modifica abilità"
  },
  "departments-page": {
    "title": "Titolo",
    "actions": " ",
    "add": "Aggiungi dipartimento",
    "add_popup": "Aggiungi dipartimento",
    "delete": "Elimina dipartimento",
    "edit": "Modifica dipartimento",
    "edit_popup": "Modifica dipartimento"
  },
  "tours-page": {
    "title": "Titolo",
    "actions": " ",
    "add": "Aggiungi tour",
    "add_popup": "Aggiungi tour",
    "delete": "Elimina tour",
    "edit": "Modifica tour",
    "edit_popup": "Modifica tour"
  },
  "library-page": {
    "title": "Titolo",
    "text": "Descrizione",
    "video": "Video",
    "courses": "Corsi",
    "video_link_copy": "Copia link",
    "video_in_process": "Video in elaborazione...",
    "is_public": "È pubblico",
    "actions": " ",
    "add": "Aggiungi video",
    "add_popup": "Aggiungi video",
    "delete": "Elimina video",
    "edit": "Modifica video",
    "edit_popup": "Modifica video"
  },
  "library-documents-page": {
    "title": "Titolo",
    "actions": " ",
    "add": "Aggiungi documento",
    "add_popup": "Aggiungi documento",
    "delete": "Elimina documento",
    "edit": "Modifica documento",
    "edit_popup": "Modifica documento",
    "file": "File"
  },
  "scorm-page": {
    "title": "Titolo",
    "actions": " ",
    "add": "Aggiungi corso",
    "loading": "Corso in caricamento...",
    "add_popup": "Aggiungi corso",
    "delete": "Elimina corso",
    "edit": "Modifica corso",
    "edit_popup": "Modifica corso",
    "zip_file": "File ZIP"
  },
  "ai-assistants-page": {
    "external_id": "ID",
    "description": "Description",
    "actions": " ",
    "add": "Aggiungi assistente AI",
    "add_popup": "Aggiungi assistente AI",
    "delete": "Elimina assistente AI",
    "edit": "Modifica assistente AI",
    "edit_popup": "Modifica assistente AI"
  },
  "ai-prompts-page": {
    "name": "Nome",
    "content": "Contenuto",
    "actions": " ",
    "add": "Aggiungi prompt AI",
    "add_popup": "Aggiungi prompt AI",
    "delete": "Elimina prompt AI",
    "edit": "Modifica prompt AI",
    "edit_popup": "Modifica prompt AI",
    "key": "Chiave dello slot",
    "model": "Modello",
    "updated_at": "Aggiornato",
    "custom": "Personalizzato",
    "description": "Descrizione",
    "temperature": "Temperature",
    "top_p": "Top P",
    "reasoning_effort": "Sforzo di ragionamento",
    "reasoning_effort_default": "Predefinito",
    "required_placeholders": "Variabili obbligatorie (devono essere presenti nel contenuto)",
    "versions": "Cronologia delle versioni",
    "no_versions": "Nessuna versione per ora",
    "restore": "Ripristina",
    "restore_confirm": "Ripristinare questa versione? Il suo contenuto diventerà quello attuale.",
    "restored": "Versione ripristinata",
    "current_version": "Attuale",
    "author": "Autore",
    "error": "Qualcosa è andato storto.",
    "tab_system": "Sistema",
    "tab_custom": "Personalizzato",
    "system_hint": "I prompt di sistema sono utilizzati dal codice della piattaforma. Non possono essere eliminati, ma il loro contenuto può essere modificato.",
    "custom_hint": "I prompt personalizzati sono collegati alle competenze e ai profili AI come sostituzione del prompt di valutazione.",
    "model_from_code": "impostato dal codice",
    "model_from_code_hint": "Il modello è scelto dal codice che utilizza il prompt; non è memorizzato nel prompt stesso.",
    "used_by": "Utilizzato da",
    "used_by_value": "Competenze: {competencies}, Profili AI: {profiles}",
    "not_used": "Non utilizzato",
    "delete_blocked_hint": "Impossibile eliminare: il prompt è utilizzato come sostituzione. {usage}",
    "slot_description": {
      "game_eval_negotiation": "Valutazione AI delle sessioni PvP: negoziazione",
      "game_eval_feedback": "Valutazione AI delle sessioni PvP: feedback",
      "game_eval_vs_ai": "Valutazione AI delle sessioni contro l'AI (se il profilo AI non ha una sostituzione)",
      "protocol_evaluation": "Compilazione del protocollo dello scenario a partire dalla trascrizione di una sessione contro l'AI",
      "voice_agent": "Prompt di sistema dell'interlocutore vocale AI",
      "scenario_generation": "Generazione dello scenario a partire da una descrizione",
      "scenario_card_update": "Aggiornamento della scheda dello scenario da una descrizione AI",
      "scenario_optimize": "Ottimizzazione della descrizione AI di uno scenario",
      "skill_report_analysis": "Rapporto sulle competenze: fase di analisi",
      "skill_report_recommendations": "Rapporto sulle competenze: fase di raccomandazioni"
    }
  },
  "ai-profiles-page": {
    "name": "Nome",
    "settings": "Impostazioni",
    "temperature": "Fantasia",
    "demeanor": "Comportamento",
    "behavior": "Comportamento, istruzioni",
    "background": "Biografia",
    "style": "Stile",
    "instructions": "Istruzioni",
    "supportive_phrases": "Frasi di supporto",
    "ai_assistant": "Assistente AI",
    "ai_starts_first": "L'AI inizia per primo",
    "first_phrase": "Prima frase",
    "closing_phrases": "Frasi di chiusura",
    "voice": "Voce",
    "expert_mode": "Modalità esperto",
    "custom_demeanor_hint": "Comportamento personalizzato attuale",
    "is_shared": "Disponibile per tutte le aziende",
    "voice_options": {
      "male": "Maschile",
      "female": "Femminile"
    },
    "demeanor_options": {
      "friendly": {
        "title": "Amichevole",
        "description": "Facilmente avvicinabile e piacevole"
      },
      "critical": {
        "title": "Critico",
        "description": "Spesso evidenzia difetti e aree di miglioramento"
      },
      "empathetic": {
        "title": "Empatico",
        "description": "Molto sensibile ai sentimenti e alle emozioni degli altri"
      },
      "enthusiastic": {
        "title": "Entusiasta",
        "description": "Mostra intensa eccitazione e impegno"
      },
      "analytical": {
        "title": "Analitico",
        "description": "Si concentra sulla logica e sulla risoluzione dettagliata dei problemi"
      },
      "curious": {
        "title": "Curioso",
        "description": "Desideroso di imparare e fare domande"
      },
      "assertive": {
        "title": "Assertivo",
        "description": "Fiducioso e sicuro di sé"
      },
      "blunt": {
        "title": "Diretto",
        "description": "Diretto e al punto"
      },
      "skeptical": {
        "title": "Scettico",
        "description": "Diffidente verso nuove soluzioni e idee"
      },
      "neutral": {
        "title": "Neutrale",
        "description": "Equilibrato e obiettivo nello stile di comunicazione"
      },
      "casual": {
        "title": "Informale",
        "description": "Rilassato e colloquiale nel tono"
      }
    },
    "placeholders": {
      "name": "Ad esempio: Sergey (educato e amichevole)",
      "demeanor": "Ad esempio: Amichevole, educato e socievole...",
      "background": "Ad esempio: È stato licenziato due volte...",
      "behavior": "Ad esempio: Non interrompe, ascolta attivamente...",
      "first_phrase": "Ad esempio: Buongiorno! Come va il suo umore?",
      "closing_phrases": "Ad esempio: Non ci resta quasi più tempo, quindi propongo di riassumere rapidamente il nostro incontro."
    },
    "actions": " ",
    "add": "Aggiungi profilo AI",
    "add_popup": "Aggiungi profilo AI",
    "subtitle": "Come appare e come suona l'interlocutore nella sessione",
    "preview": {
      "title": "Anteprima",
      "unnamed": "Senza nome",
      "voice": "voce {name}",
      "defaultVoice": "voce predefinita",
      "defaultPhoto": "Foto predefinita",
      "listen": "Ascolta la voce",
      "defaultVoiceNotice": "La voce verrà scelta all'inizio della sessione: non è possibile ascoltarla prima",
      "photoPlaceholder": "La foto apparirà qui"
    },
    "delete": "Elimina profilo AI",
    "edit": "Modifica profilo AI",
    "edit_popup": "Modifica profilo AI",
    "avatar_hint": "immagine dell'avatar",
    "avatar_save_first": "Salva prima il profilo per abilitare il caricamento dell'avatar",
    "avatar_requirements": "Max 1 MB • Consigliato: 1536×1024 • Proporzioni: 3:2",
    "max_characters": "Massimo {max} caratteri"
  },
  "games-page": {
    "game-with-ai": "Sessione con IA",
    "organization": "Organizzazione",
    "status": "Stato",
    "failure_reasons": {
        "protocol_not_agreed": "Il protocollo non è stato concordato dai partecipanti",
        "protocol_approval_expired": "Il tempo per l'approvazione del protocollo è scaduto",
        "annulled": "La sessione è stata annullata",
        "expired": "Il tempo della sessione è scaduto",
        "assignment_changed": "L'assegnazione del corso è cambiata nel sistema di formazione"
    },
    "restore": "Restore",
    "play": "Gioca",
    "meetings_unavailable": "Le sessioni video tra i partecipanti sono temporaneamente non disponibili. Riprova più tardi.",
    "import": "Importa",
    "scenario": "Scenario",
    "tour": "Tour",
    "game_types": {
      "classic": "Modalità classica",
      "vs_ai": "Sessione contro AI",
      "uploaded_recording": "Registrazione"
    },
    "upload_recording": {
      "file": "File della registrazione",
      "file_hint": "Video o audio, fino a 1 GB",
      "uploaded": "File caricato",
      "file_too_large": "Il file supera 1 GB",
      "upload_error": "Impossibile caricare il file",
      "player": "Partecipante",
      "rate_both": "Valuta entrambi i partecipanti",
      "second_player": "Secondo partecipante",
      "open_session": "Apri la sessione"
    },
    "game_targets": {
      "user": "Partecipante",
      "position": "Ruolo",
      "department": "Dipartimento"
    },
    "number": "Numero",
    "start_up_to": "Inizia fino a",
    "start_time": "Ora di inizio",
    "teamA": "Squadra A",
    "teamB": "Squadra B",
    "others": "Partecipanti",
    "actions": " ",
    "edit_results": "Modifica risultati",
    "add": "Aggiungi sessione",
    "add_popup": "Aggiungi sessione",
    "delete": "Elimina sessione",
    "edit": "Modifica sessione",
    "edit_popup": "Modifica sessione",
    "time_scheduling": "Pianificazione orario di inizio",
    "return_to_time_scheduling": "Tornare al coordinamento dell’orario di inizio",
    "preparation": "Preparazione per la sessione",
    "view_scenario": "Visualizza scenario",
    "protocol": "Approvazione protocollo",
    "not_agreed": "Non concordato",
    "expert-accept": "Accetta e procedi alla valutazione",
    "expert-decline": "Rifiuta",
    "hide_ai_results": "Nascondi valutazione AI",
    "show_ai_results": "Mostra valutazione AI",
    "mark_failed": "Segna come fallita",
    "popup": {
      "start_up_to": "Inizia fino a",
      "target": "A chi assegnare la sessione?",
      "custom_field_value": "Valore di «{field}»",
      "target_preview_count": "Sessioni da creare: {count}",
      "target_preview_empty": "Nessun giocatore corrisponde a questo segmento: non verrà creata alcuna sessione",
      "target_preview_limit_exceeded": "È più di quanto una singola assegnazione possa creare (al massimo {limit}). Riduci il segmento, il numero di casi o il numero di copie",
      "copies_per_player": "Copie di ogni caso per giocatore",
      "position": "Ruolo",
      "department": "Dipartimento",
      "scenario": "Scenario",
      "optional": "Opzionale, può essere omesso",
      "protocol_time": "Tempo protocollo",
      "protocol_time_hint": "Numero tra 1 e 1440",
      "preparation_time": "Tempo di preparazione",
      "preparation_time_hint": "In minuti",
      "game_duration": "Durata della sessione",
      "game_duration_hint": "Numero tra 1 e 60",
      "is_team": "Scenario per squadre",
      "is_camera_required": "Le telecamere dei partecipanti sono richieste",
      "is_self_rated": "I partecipanti possono autovalutarsi",
      "is_each_other_rated": "I partecipanti possono valutarsi a vicenda",
      "is_expert_rated": "La valutazione dell'esperto è disponibile",
      "is_ai_rated": "La valutazione AI è disponibile",
      "show_results": "Mostra risultati",
      "automatically": "automaticamente",
      "manually": "manualmente",
      "is_public_hint": "Qualsiasi osservatore potrà connettersi",
      "is_public": "Sessione pubblica",
      "team_a": "Squadra A",
      "team_b": "Squadra B",
      "player_a": "Partecipante A",
      "player_b": "Partecipante B",
      "expert": "Esperto",
      "observers": "Osservatori",
      "tour": "Tour",
      "search": "Cerca...",
      "choose_players": "Scegli partecipanti",
      "choose_expert": "Scegli esperto",
      "choose_observers": "Scegli osservatori",
      "choose_scenario": "Scegli scenario",
      "choose_tour": "Scegli tour",
      "expert_empty": "Se non selezionato, il capitano potrà scegliere",
      "captain": "Capitano",
      "": "",
      "protocol": {
        "title": "Approvazione protocollo",
        "target": "Obiettivo",
        "await_approval": "In attesa dell'approvazione dell'avversario",
        "await_proposal": "In attesa della proposta dell'avversario",
        "questions": "Domande per la tua squadra",
        "questions_a": "Domande per la squadra A",
        "questions_b": "Domande per la squadra B",
        "not_agreed": "Non si sono accordati",
        "not_agreed_confirm": "La sessione si concluderà senza successo e i risultati non verranno conteggiati. Questa azione è irreversibile.",
        "not_agreed_done": "La sessione si è conclusa senza successo."
      },
      "start_time": {
        "title": "Ora di inizio",
        "must_start_by": "Deve iniziare entro"
      },
      "edit_results": {
        "title": "Modifica risultati"
      },
      "preparation": {
        "title": "Preparazione per la sessione",
        "description": "Descrizione",
        "description_team": "Descrizione per la squadra",
        "notes": "Note personali"
      },
      "import": {
        "download_example": "Scarica esempio",
        "title": "Importazione sessioni",
        "button": "Inizia importazione",
        "label": "File Excel"
      },
      "create_multi_scenario_games_immediately": "Tutte le sessioni saranno create immediatamente",
      "create_multi_scenario_games_sequentially": "Le sessioni saranno create sequenzialmente (dopo il completamento con successo di ciascuna)"
    }
  },
  "ai-game": {
    "title": "Sessione contro AI",
    "recording": "Registrazione",
    "ai": "AI",
    "you": "Tu",
    "ai_ready": "Pronto",
    "camera_off": "La telecamera è spenta",
    "stop_game": "Ferma sessione",
    "start_game": "Inizia sessione",
    "mic_permission": "Concedi i permessi del microfono nelle impostazioni per iniziare la sessione",
    "permissions_granted": "Permessi concessi con successo!",
    "close": "Chiudi",
    "microphone_required": "Please grant microphone permissions to start the session",
    "mic_required": "Attiva il microfono per iniziare la sessione",
    "mic_not_detected": "Nessun suono rilevato — prova a parlare o controlla il microfono",
    "permissions_needed": "L'accesso al microfono è obbligatorio. La fotocamera è facoltativa",
    "agent": {
      "initializing": "Initializing...",
      "listening": "Listening",
      "thinking": "Thinking...",
      "speaking": "Speaking",
      "waiting": "Waiting for agent..."
    },
    "waiting_for_start": "Start the session to begin conversation",
    "grant_microphone": "Grant Microphone Access",
    "game_not_found": "Session Not Found",
    "game_not_found_desc": "Session with ID {id} could not be located.",
    "confirm": {
      "start_question": "Sei sicuro? La sessione non può essere messa in pausa",
      "start_title": "Sessione Avviata",
      "start_success": "La sessione è stata avviata con successo",
      "start_cancel_title": "Sessione Non Avviata",
      "start_cancel_msg": "L'avvio della sessione è stato annullato",
      "end_question": "Sei sicuro? La sessione verrà terminata",
      "end_title": "Sessione Terminata",
      "end_success": "La sessione è stata terminata con successo",
      "end_cancel_title": "Sessione Non Terminata",
      "end_cancel_msg": "La fine della sessione è stata annullata"
    },
    "voice": {
      "disconnected": "Disconnesso",
      "connecting": "Connessione in corso...",
      "connected": "Connesso al server",
      "connection_error": "Impossibile connettersi all'agente vocale",
      "game_already_finished": "Questa partita è già terminata",
      "connection_timeout": "Connection to voice server timed out. This may be caused by a firewall or network restrictions. Check your network settings and try again.",
      "no_rooms_available": "Nessuna stanza disponibile al momento. Riprova più tardi.",
      "preparing_recording": "Preparazione della registrazione, nuovo tentativo tra {seconds}s…",
      "recording_service_overloaded": "Il servizio di registrazione è sovraccarico. Riprovare tra qualche minuto.",
      "session_quota_exhausted": "Il pacchetto sessioni della tua organizzazione è esaurito. Contatta il tuo responsabile.",
      "connection_blocked": "La tua rete ha bloccato la creazione della connessione con l'IA. Consenti HTTPS (443) verso i domini richiesti e riprova.",
      "connection_blocked_signaling": "Il firewall o il proxy della tua rete sta bloccando la connessione al server vocale. Prova a connetterti da un'altra rete o da un hotspot mobile.",
      "reconnecting": "Reconnecting...",
      "disconnect_dialog_title": "Connection Lost",
      "disconnect_dialog_message": "The connection was interrupted. Would you like to reconnect or finish the session?",
      "disconnect_retry": "Reconnect",
      "disconnect_finish": "Finish Session",
      "agent_join_timeout": "The AI agent did not connect in time. Please try again.",
      "stop_failed": "Failed to stop the session",
      "mic_enable_failed": "Microphone could not be enabled. You can try toggling it manually.",
      "mic_toggle_failed": "Failed to toggle microphone",
      "camera_toggle_failed": "Failed to toggle camera",
      "duplicate_tab_title": "Session Open in Another Tab",
      "duplicate_tab_message": "This session is already active in another browser tab. Close the other tab and reopen this page if you want to continue here.",
      "duplicate_tab_back": "Go Back",
      "duplicate_tab_disconnect_title": "Opened in Another Tab",
      "duplicate_tab_disconnect_message": "This tab was disconnected because the session is already active in another tab. Return to the session page from here."
    },
    "permissions_denied_safari": "L'accesso alla fotocamera o al microfono è stato negato. Vai su Impostazioni Safari > Siti web > Fotocamera/Microfono e consenti l'accesso per questo sito.",
    "supported": "Browser supportato"
  },
  "positions-page": {
    "title": "Titolo",
    "actions": " ",
    "add": "Aggiungi posizione",
    "add_popup": "Aggiungi posizione",
    "delete": "Elimina posizione",
    "edit": "Modifica posizione",
    "edit_popup": "Modifica posizione"
  },
  "user-custom-fields-page": {
    "title": "Titolo",
    "type": "Tipo",
    "options_count": "Valori",
    "actions": " ",
    "add": "Aggiungi campo",
    "add_popup": "Aggiungi campo",
    "delete": "Elimina campo",
    "delete_confirm": "Eliminare il campo? I valori salvati per gli utenti non verranno più visualizzati.",
    "edit": "Modifica campo",
    "edit_popup": "Modifica campo",
    "empty": "Nessun campo personalizzato",
    "error": "Impossibile salvare il campo",
    "type_text": "Testo",
    "type_select": "Elenco",
    "type_locked_hint": "Il tipo non può essere modificato dopo la creazione del campo",
    "options": "Valori",
    "options_hint": "L'ordine dei valori qui è l'ordine nell'elenco a discesa",
    "options_required": "Aggiungi almeno un valore",
    "option_title": "Valore",
    "option_add": "Aggiungi valore",
    "option_delete": "Elimina valore",
    "option_delete_confirm": "Eliminare il valore? Verrà rimosso dagli utenti che lo avevano selezionato.",
    "option_move_up": "Sposta su",
    "option_move_down": "Sposta giù"
  },
  "organizations-page": {
    "name": "Nome",
    "host": "Ospite",
    "duel_limit": "Limite duello",
    "max_users": "Max utenti",
    "max_users_hint": "0 = illimitato",
    "max_vs_ai_games_per_scenario": "Max partite IA per giocatore per scenario",
    "max_vs_ai_games_per_scenario_hint": "Vuoto = nessun limite. Si applica alla creazione autonoma di partite da parte del giocatore",
    "employee_report_daily_limit": "Limite di rapporti sui dipendenti al giorno",
    "employee_report_daily_limit_hint": "Vuoto = limite della piattaforma. Si applica a manager e responsabili",
    "employee_report_hourly_limit": "Limite di rapporti sui dipendenti all'ora",
    "employee_report_hourly_limit_hint": "Vuoto = limite della piattaforma. Si applica a manager e responsabili",
    "registration": "Registrazione aperta",
    "timezone": "Fuso orario",
    "locale": "Lingua",
    "users_count": "Utenti",
    "actions": " ",
    "add": "Aggiungi organizzazione",
    "add_popup": "Aggiungi organizzazione",
    "delete": "Elimina organizzazione",
    "edit": "Modifica organizzazione",
    "edit_popup": "Modifica organizzazione",
    "available_languages": "Lingue disponibili",
    "show_game_numbers_for_player": "Mostra numeri delle sessioni per il partecipante",
    "allow_players_choose_expert": "Permetti ai partecipanti di scegliere l'esperto",
    "send_message": "Invia messaggio ai manager",
    "message": "Messaggio",
    "send": "Invia",
    "clear_message": "Cancella messaggio",
    "current_message": "Messaggio attuale",
    "two_factor_method": "Autenticazione a due fattori",
    "two_factor_disabled": "Disattivata",
    "two_factor_email": "Email",
    "two_factor_sms": "SMS",
    "hidden_menu_items": "Hidden menu items",
    "hide_ai_results": "Nascondi risultati IA",
    "hide_player_rating": "Nascondi la classifica aziendale ai partecipanti",
    "show_character_memory_to_player": "Mostra la memoria del personaggio al giocatore",
    "show_meeting_recap_to_player": "Mostra il riepilogo dell’incontro al giocatore",
    "create_user_on_external_launch": "Crea un utente alla prima richiesta di un sistema esterno",
    "create_user_on_external_launch_hint": "Se disattivata, un utente che il sistema esterno porta per la prima volta riceve un rifiuto anziché una sessione. Ogni utente creato in questo modo occupa un posto nell'abbonamento.",
    "allow_external_email_linking": "Permetti di collegare un utente esterno tramite email",
    "allow_external_email_linking_hint": "Se attivata, una persona esterna viene collegata a un utente già esistente se il sistema esterno ha comunicato il suo indirizzo email dal proprio server. Se disattivata, un accesso di questo tipo viene rifiutato e non viene creato un secondo utente con lo stesso indirizzo."
  },
  "users-page": {
    "import": "Importa",
    "user": "Utente",
    "roles": "Ruoli",
    "effectiveness": "Efficacia",
    "department": "Dipartimento",
    "position": "Posizione",
    "status": "Stato",
    "actions": " ",
    "add": "Aggiungi utente",
    "add_popup": "Nuovo utente",
    "last_login_at": "Ultimo accesso",
    "delete": "Elimina",
    "view": "Visualizza",
    "login": "Login",
    "message": "Messaggio",
    "activate": "Attiva",
    "deactivate": "Blocca",
    "edit_popup": "Modifica utente",
    "total_in_org": "Totale nell'organizzazione",
    "multi_role_note": "Un utente con più ruoli viene conteggiato in ogni badge",
    "filter_role": "Ruolo",
    "all_roles": "Tutti i ruoli",
    "filter_activity": "Scenari completati",
    "activity_played": "Sì",
    "activity_not_played": "No",
    "filter_activity_from": "Completati dal",
    "filter_last_login_from": "Data di accesso",
    "filter_custom_field": "Campo personalizzato",
    "filter_custom_field_value": "Valore di «{field}»",
    "last_login_never": "Mai acceduto",
    "last_login_since": "Accesso da",
    "cases_progress": "Casi completati",
    "cases_progress_value": "{completed} su {assigned}",
    "export": "Esporta",
    "popup": {
      "name": "Nome",
      "last_name": "Cognome",
      "patronymic": "Patronimico",
      "phone": "Telefono",
      "timezone": "Fuso orario",
      "language": "Lingua",
      "country": "Paese",
      "invalid_phone": "Numero di telefono errato",
      "department": "Dipartimento",
      "position": "Posizione",
      "effectiveness": "Efficacia",
      "roles": "Ruoli",
      "organizations": "Aziende",
      "blocked": "Bloccato",
      "is_active": "È attivo",
      "email_verified": "Email verificata",
      "email_not_verified": "Email non verificata",
      "subordinates": "Subordinati",
      "search_subordinates": "Cerca partecipanti...",
      "import": {
        "download_example": "Scarica esempio",
        "title": "Importazione utenti",
        "button": "Inizia importazione",
        "label": "File Excel",
        "marker_hint": "Per un utente già esistente, una cella vuota mantiene il valore attuale e un trattino (-) svuota il campo.",
        "result_title": "Importazione avviata",
        "result_created": "Verranno creati: {count}",
        "result_updated": "Verranno aggiornati: {count}",
        "result_skipped": "Ignorate: {count}",
        "result_skipped_row": "Riga {row}, {email}: {reason}",
        "result_truncated": "…e altre {count} righe ignorate"
      }
    }
  },
  "users-ranking-page": {
    "user": "Utente",
    "roles": "Ruoli",
    "effectiveness": "Efficacia",
    "average-effectiveness": "Media per sessione",
    "sessions-count": "Sessioni",
    "department": "Dipartimento",
    "position": "Posizione",
    "status": "Stato",
    "export": "Esporta",
    "actions": " "
  },
  "user-detail": {
    "games_finished": "Sessioni Completate",
    "not_found": "Utente non trovato",
    "games_total": "Totale",
    "username": "Nome utente",
    "phone": "Telefono",
    "status": "Stato",
    "language": "Lingua",
    "timezone": "Fuso orario",
    "edit": "Modifica",
    "department": "Dipartimento",
    "position": "Posizione",
    "activate": "Attiva",
    "block": "Blocca",
    "account": {
      "title": "Account",
      "summary": {
        "title": "Sommario",
        "games": "Sessioni giocate",
        "place": "Posizione",
        "effectiveness": "Efficacia",
        "time": "Tempo"
      }
    },
    "security": {
      "title": "Sicurezza",
      "change_password_title": "Cambia password",
      "change_password": "Cambia password",
      "new_password": "Nuova password",
      "confirm_new_password": "Conferma nuova password",
      "password_requirements": "Requisiti Password:",
      "password_requirements_1": "Lunga minimo 8 caratteri - più è lunga, meglio è",
      "password_requirements_2": "Almeno un carattere minuscolo",
      "password_requirements_3": "Almeno un numero, simbolo o spazio"
    },
    "statistics": {
      "title": "Statistiche"
    }
  },
  "game": {
    "character_memory": {
      "title": "Cosa ricorda il personaggio",
      "subtitle": "La memoria degli incontri passati che il personaggio porta in questa partita",
      "preview_subtitle": "La memoria non è ancora definita: il personaggio la riceve nel momento in cui inizia la partita",
      "unavailable": "L’incontro precedente non è disponibile per il personaggio: inizierà la conversazione senza ricordarlo.",
      "agreements": "Accordi",
      "player_commitments": "Impegni del giocatore",
      "character_commitments": "Impegni del personaggio",
      "open_issues": "Questioni aperte",
      "facts": "Fatti citati",
      "attitude": "Atteggiamento verso il giocatore",
      "evaluation_passed": "I risultati della valutazione di quell’incontro sono stati trasmessi al personaggio",
      "evaluation_not_ready": "La valutazione di quell’incontro non è ancora pronta: il personaggio la riceverà una volta calcolata.",
      "evaluation_hidden": "I testi della valutazione sono nascosti dalle impostazioni dell’organizzazione.",
      "overall_effectiveness": "Efficacia complessiva",
      "outcome": {
        "deal": "Accordo",
        "partial": "Parziale",
        "no_deal": "Nessun accordo",
        "unclear": "Non chiaro"
      }
    },
    "meeting_recap": {
      "title": "Riepilogo dell’incontro",
      "outcome": "Esito dell’incontro",
      "agreements": "Accordi",
      "player_commitments": "Impegni del giocatore",
      "character_commitments": "Impegni del personaggio",
      "open_issues": "Questioni aperte",
      "facts": "Fatti citati",
      "pending": "Il riepilogo dell’incontro è ancora in preparazione. Riprova a controllare un po’ più tardi.",
      "unavailable": "Non è stato possibile creare il riepilogo di questo incontro.",
      "none": "Non c’è nessun riepilogo per questa partita."
    },
    "title": "Sessione",
    "team": "Squadra",
    "expert": "Esperto",
    "points": "punti",
    "your_result": "Il tuo risultato",
    "joined_at": "Entrato:",
    "ended_at": "Data di completamento",
    "min": "min.",
    "duration": "Durata",
    "from_average": "dalla media",
    "ai_expert": "Esperto AI",
    "ai_evaluation_in_progress": "Valutazione AI in corso",
    "delete_ai_request": "Elimina feedback AI",
    "ai_expert_refresh": "Aggiorna Risultati AI",
    "ai_expert_refresh_rejected": {
      "evaluation_not_completed": "Al momento non è possibile aggiornare i risultati AI: la valutazione AI è ancora in corso.",
      "answer_pending": "Al momento non è possibile aggiornare i risultati AI: la risposta dell'AI non è ancora arrivata.",
      "recognition_pending": "Al momento non è possibile aggiornare i risultati AI: la registrazione è ancora in fase di trascrizione.",
      "recognition_has_no_speech": "Nella registrazione non è stato riconosciuto alcun parlato: i risultati AI non possono essere aggiornati.",
      "recognition_has_too_little_speech": "Nella registrazione non c'è quasi nessuna conversazione tra i partecipanti, quindi la valutazione AI non è stata eseguita.",
      "no_ai_evaluation": "Questa sessione non ha più una valutazione AI.",
      "game_evaluation_blocked": "La sessione non si è svolta o è stata annullata, quindi la valutazione AI non è disponibile."
    },
    "ai_expert_unavailable": {
      "recognition_has_no_speech": "Nella registrazione non è stato riconosciuto alcun parlato, quindi la valutazione AI non è stata eseguita.",
      "recognition_has_too_little_speech": "Nella registrazione non c'è quasi nessuna conversazione tra i partecipanti, quindi la valutazione AI non è stata eseguita.",
      "game_evaluation_blocked": "La sessione non si è svolta o è stata annullata, quindi la valutazione AI non è disponibile."
    },
    "ai_expert_refresh_failed": "Impossibile aggiornare i risultati AI.",
    "speaker_mapping": {
      "title": "Partecipanti e voci",
      "voice": "Voce {number}",
      "unknown": "Non identificato",
      "needs_review": "Controlla i partecipanti",
      "needs_review_hint": "I partecipanti potrebbero essere stati identificati in modo errato: assicurati che il feedback AI sia arrivato alle persone giuste.",
      "failed": "Non è stato possibile identificare automaticamente i partecipanti.",
      "unavailable": "Il provider AI non era disponibile; i partecipanti verranno identificati alla prossima valutazione.",
      "empty": "La trascrizione non contiene interventi da cui identificare i partecipanti.",
      "corrected_manually": "Corretto manualmente",
      "under_reevaluation": "La valutazione AI è in corso con questi partecipanti. Finché non sarà completata, la pagina mostra i risultati precedenti.",
      "confirm": "I partecipanti sono corretti",
      "review": "Verifica",
      "dialog_hint": "Assegna un partecipante a ciascuna voce. Dopo il salvataggio, il feedback AI verrà richiesto di nuovo.",
      "save": "Salva",
      "cancel": "Annulla",
      "confirmed": "Partecipanti confermati",
      "fixed": "Partecipanti corretti, feedback AI richiesto di nuovo",
      "action_failed": "Impossibile completare l'azione"
    },
    "ai_expert_created": "Il processo di valutazione della sessione è iniziato. Ci vorranno alcuni minuti. Puoi lasciare la pagina, poiché ti invieremo una notifica quando la valutazione sarà disponibile.",
    "expert_already_requested": "La valutazione è già stata richiesta da un altro partecipante",
    "request_expert": "Richiedi Esperto",
    "assign_expert": "Assegna Esperto",
    "ai_process": "Attendere prego, elaborazione in corso",
    "analyzing_results": "Analisi dei risultati della sessione...",
    "complete_expert_request": "Completa la valutazione",
    "tabs": {
      "description": {
        "title": "Descrizione dello Scenario",
        "subtitle": "Informazioni e regole della sessione",
        "situation": "Situazione",
        "your_role": "Il tuo ruolo",
        "player_role": "Ruolo del giocatore: {name}",
        "team_tab": "Squadra {team}",
        "empty": "Questa sessione non ha descrizioni.",
        "load_error": "Impossibile caricare la descrizione. Riprova più tardi."
      },
      "results": {
        "title": "Risultati",
        "effectiveness_summary": "Efficacia del team",
        "your_effectiveness": "La tua efficacia",
        "parameters_section": "Parametri",
        "parameter": "Parametro",
        "target": "Obiettivo",
        "coefficient": "Coefficiente",
        "value": "accordo comune",
        "points": "Punti",
        "points_short": "punti",
        "combinations": "Combinazioni",
        "combination_bonus": "Bonus combinazione",
        "questions": "Domande",
        "question": "Domanda",
        "answer": "Risposta",
        "total": "Totale"
      },
      "comments": {
        "title": "Analisi Video",
        "comments": "Commenti",
        "no_comments": "Ancora nessun commento",
        "no_video": "Video non disponibile",
        "video_processing": "Il video è in fase di elaborazione...",
        "count": "commenti",
        "delete": "Elimina",
        "edit": "Modifica",
        "popup": {
          "add": "Aggiungi commento",
          "edit": "Modifica commento",
          "comment": "Commento",
          "player": "Partecipante",
          "all": "A tutti"
        }
      },
      "feedback": {
        "title": "Valutazione della Sessione",
        "no_feedback": "Ancora nessuna valutazione",
        "no_feedback_description": "Il feedback per questa sessione non è ancora stato aggiunto",
        "overall_score": "Punteggio Totale",
        "skills_evaluated": "{count} competenze valutate",
        "no_comment": "Nessun commento fornito",
        "score_button": "Valuta Partecipante",
        "player": "Partecipante",
        "author": "Autore",
        "download": "Scarica video",
        "download_transcript": "Scarica trascrizione",
        "evaluators": {
          "ai": "Esperto",
          "expert": "Esperto",
          "player": "Partecipante",
          "manager": "Manager",
          "head": "Responsabile"
        },
        "popup": {
          "score": {
            "title": "Valutazione del Partecipante",
            "comment": "Commento",
            "error": "Devi valutare tutte le abilità del partecipante",
            "save_error": "Impossibile salvare la valutazione. Potresti non avere l'autorizzazione per valutare questo partecipante."
          }
        }
      },
      "checklist": {
        "title": "Checklist",
        "total": "Elementi superati",
        "pass": "Superato",
        "fail": "Non superato",
        "cannot_assess": "Non valutabile",
        "comment": "Commento generale",
        "category": "Categoria",
        "author": "Valutatore",
        "player": "Partecipante",
        "passed_of": "{passed} di {total}",
        "evidence": "Evidenza",
        "rationale": "Motivazione",
        "no_results": "Ancora nessuna valutazione della checklist",
        "no_results_description": "Questa sessione non è ancora stata valutata in base a una checklist"
      }
    }
  },
  "scenario": {
    "steps": {
      "information": {
        "create_new_ai_profile": "Crea nuovo",
        "edit_ai_profile": "Modifica",
        "delete_ai_profile": "Elimina",
        "confirm_delete_ai_profile": "Sei sicuro di voler eliminare questo profilo AI?",
        "first_header": "Impostazioni di Base",
        "second_header": "Partecipante AI",
        "third_header": "Descrizione Scenario",
        "is_public": "Pubblico",
        "is_public_hint": "Se abilitato — lo scenario sarà disponibile per la selezione da parte dei partecipanti.",
        "title": "Informazioni",
        "subtitle": "Dati di base dello scenario",
        "image": "immagine scenario",
        "field_title": "Titolo",
        "competence": "Competenza",
        "description": "Descrizione",
        "description_a": "Descrizione per la squadra A",
        "description_b": "Descrizione per la squadra B",
        "next_scenario_label": "Scenario Successivo",
        "next_scenario_placeholder": "Non selezionato",
        "next_scenario_hint": "Dopo aver completato la sessione con questo scenario, verrà automaticamente creata una sessione con lo scenario successivo.",
        "memory_header": "Collegamento al prossimo incontro",
        "memory_group_evaluation": "La valutazione del prossimo incontro",
        "memory_group_character": "Il personaggio del prossimo incontro",
        "memory_pass_to_next": "ricorda questo incontro",
        "memory_pass_to_next_hint": "Il personaggio del prossimo scenario avvia la conversazione come con una persona che già conosce: riceve un breve riepilogo di questo incontro, gli accordi raggiunti, gli impegni di entrambe le parti, le questioni aperte e i fatti citati. La registrazione e le citazioni testuali non gli vengono trasmesse. Attivi questa opzione quando il prossimo incontro prosegue questo: un secondo round di trattative, un incontro individuale ricorrente.",
        "memory_pass_evaluation_to_next": "conosce la valutazione di questo incontro",
        "memory_pass_evaluation_to_next_hint": "Insieme alla memoria, il personaggio riceve i testi di feedback sulle competenze e il risultato complessivo di questo incontro, così può comportarsi come un coach che ricorda cosa il giocatore ha fatto bene.",
        "memory_evaluate_next_with_agreements": "tiene conto degli accordi di questo incontro",
        "memory_evaluate_next_with_agreements_hint": "Nel valutare il prossimo incontro, l’esperto IA vede gli accordi, gli impegni di entrambe le parti e le questioni aperte di questo incontro, e può verificare se il giocatore ha mantenuto la parola data. I punteggi e i testi di valutazione dell’incontro precedente non vengono trasmessi, in modo che non influenzino il nuovo punteggio.",
        "ai_profile": "Profilo AI",
        "ai_profile_placeholder": "Solo per sessioni AI",
        "ai_description": "Descrizione AI",
        "optimize_ai_description": "Optimize with AI",
        "optimizing_in_progress": "AI is optimizing the description. Please wait...",
        "optimize_error": "Failed to optimize the description. Please try again.",
        "ai_description_hint": "Scrivere un prompt IA efficace richiede esperienza. Un prompt scritto male può portare a un comportamento imprevedibile dello scenario. Se non sei sicuro, usa il pulsante «Ottimizza con IA», prova la generazione di scenari o contatta il tuo responsabile.",
        "knowledge_base_header": "Knowledge Base",
        "knowledge_base_documents": "Documenti della Knowledge Base",
        "knowledge_base_documents_hint": "Allega documenti per fornire contesto al giocatore IA",
        "knowledge_base_no_documents": "Nessun documento disponibile. Carica i documenti nella pagina \"Knowledge Base\".",
        "knowledge_base_chunks": "{count} frammenti",
        "knowledge_base_purpose_voice": "Sessione IA",
        "knowledge_base_purpose_eval": "Valutazione"
      },
      "settings": {
        "title": "Impostazioni",
        "subtitle": "Configurazione scenario",
        "min_players": "Partecipanti minimi",
        "min_players_hint": "Numero tra 2 e 20",
        "max_players": "Partecipanti massimi",
        "max_players_hint": "Numero tra 2 e 20",
        "protocol_time": "Tempo protocollo (min)",
        "protocol_time_hint": "Numero tra 1 e 1440",
        "preparation_time": "Tempo di preparazione (min)",
        "preparation_time_hint": "Numero tra 0 e 1440. 0 - la descrizione è immediatamente visibile",
        "game_duration": "Durata della sessione (min)",
        "game_duration_hint": "Numero tra 1 e 60",
        "is_team": "Scenario per squadre",
        "is_camera_required": "Le telecamere dei partecipanti sono richieste",
        "is_self_rated": "I partecipanti possono autovalutarsi",
        "is_each_other_rated": "I partecipanti possono valutarsi a vicenda",
        "is_expert_rated": "La valutazione dell'esperto è disponibile",
        "is_ai_rated": "La valutazione AI è disponibile",
        "show_results": "Mostra risultati",
        "automatically": "automaticamente",
        "manually": "manualmente"
      },
      "parameters": {
        "title": "Parametri",
        "subtitle": "Parametri del partecipante",
        "field_title": "Titolo",
        "team_a": "Squadra A",
        "team_b": "Squadra B",
        "player_a": "Partecipante A",
        "player_b": "Partecipante B",
        "points": "Punti",
        "ratio": "Rapporto",
        "add": "Aggiungi parametro"
      },
      "questions": {
        "title": "Domande",
        "subtitle": "Domande per i partecipanti",
        "question": "Domanda",
        "team": "Squadra",
        "team_placeholder": "Seleziona Squadra",
        "answers": "Risposte",
        "points": "Punti",
        "select_answers": "Seleziona risposte",
        "add_combination": "Aggiungi combinazione",
        "add_question": "Aggiungi domanda"
      },
      "next": "Avanti",
      "previous": "Indietro",
      "save": "Salva"
    },
    "saved": "Scenario salvato",
    "to_list": "Torna all'elenco",
    "add_detail": "Aggiungi scenario",
    "edit_detail": "Modifica scenario"
  },
  "notifications": {
    "title": "Notifiche",
    "mark_unread": "Segna tutto come non letto",
    "mark_read": "Segna tutto come letto",
    "delete_all": "Elimina tutto",
    "no_new": "Nessuna notifica trovata",
    "system": "Sistema",
    "evaluation": {
      "ready": {
        "subject": "Valutazione della Sessione #:gameNumber",
        "text": "La sessione è stata valutata da un esperto"
      }
    },
    "game": {
      "created": {
        "game_assigned": "Ti è stata assegnata una sessione",
        "role": "Ruolo:"
      },
      "proposal": {
        "subject": "Coordinamento del tempo della sessione",
        "time": "Tempo:",
        "description": "Si prega di confermare o proporre la propria opzione"
      },
      "agreed": {
        "subject": "Tempo della sessione concordato",
        "time": "Tempo:",
        "description": "La descrizione e le opzioni di preparazione saranno disponibili :preparationTime minuti prima dell'inizio",
        "description_zero": "Puoi ora rivedere la descrizione dello scenario e prepararti"
      },
      "preparation": {
        "subject": "Preparazione per la sessione",
        "text": "La preparazione è disponibile."
      },
      "started": {
        "subject": "La Sessione #:gameNumber è iniziata",
        "text": "Unisciti!"
      },
      "missed": {
        "subject": "La sessione #:gameNumber è stata persa",
        "text": "Spiacenti, hai perso la sessione"
      },
      "completed": {
        "subject": "Sessione #:gameNumber completata",
        "text": "Sessione riuscita"
      },
      "failed": {
        "subject": "Sessione #:gameNumber fallita",
        "text": "Completato senza successo"
      },
      "results": {
        "proposed": {
          "subject": "Protocollo di sessione #:gameNumber concordato",
          "text": "Accordo disponibile"
        },
        "declined": {
          "subject": "Protocollo di sessione #:gameNumber rifiutato",
          "text": "Proposta rifiutata"
        },
        "not_agreed": {
          "subject": "Sessione #:gameNumber: le parti non hanno trovato un accordo",
          "text": "Il capitano avversario ha indicato che le parti non hanno trovato un accordo. La sessione si è conclusa senza successo e i risultati non sono stati conteggiati."
        }
      },
      "meeting": {
        "ended-player": {
          "subject": "Incontro di Sessione #:gameNumber Concluso",
          "text": "Si prega di attendere i risultati."
        },
        "ended-captain": {
          "subject": "Incontro di Sessione #:gameNumber Concluso",
          "text_fill": "Si prega di compilare il protocollo.",
          "text_wait": "Si prega di attendere che il protocollo venga completato.",
          "protocol_time": "Tempo di protocollo (minuti): :protocolTime"
        }
      }
    }
  },
  "profile": {
    "avatar_allowed": "Consentito JPG, GIF o PNG. Dimensione massima di 2MB",
    "avatar_label_choose": "Scegli",
    "avatar_label_your_avatar": "il tuo avatar",
    "name": "Nome",
    "last_name": "Cognome",
    "patronymic": "Patronimico",
    "phone": "Telefono",
    "timezone": "Fuso orario",
    "language": "Lingua",
    "country": "Paese",
    "invalid_phone": "Numero di telefono errato",
    "save_changes": "Salva modifiche",
    "account": "Account",
    "security": "Sicurezza",
    "statistics": "Statistiche",
    "notifications": "Notifiche",
    "change_password_title": "Cambia password",
    "change_password": "Cambia password",
    "current_password": "Password corrente",
    "new_password": "Nuova password",
    "confirm_new_password": "Conferma nuova password",
    "password_requirements": "Requisiti Password:",
    "password_requirements_1": "Lunga minimo 8 caratteri - più è lunga, meglio è",
    "password_requirements_2": "Almeno un carattere minuscolo",
    "password_requirements_3": "Almeno un numero, simbolo o spazio",
    "two_factor_title": "Autenticazione a due fattori",
    "two_factor_description": "Aggiungi un ulteriore livello di sicurezza al tuo account",
    "two_factor_org_enforced": "L'autenticazione a due fattori è obbligatoria per la tua organizzazione",
    "two_factor_method": "Metodo di autenticazione",
    "two_factor_disabled": "Disattivata",
    "two_factor_email": "Email",
    "two_factor_sms": "SMS",
    "two_factor_save": "Salva impostazioni 2FA"
  },
  "auth": {
    "password": "Password",
    "new_password": "Nuova password",
    "remember": "Ricordami",
    "timezone": "Fuso orario",
    "forgot": "Password dimenticata",
    "login": "Accedi",
    "login_title": "Accedi",
    "new_password_title": "Cambia password",
    "change_password": "Salva",
    "country": "Paese",
    "invalid_phone": "Numero di telefono errato",
    "privacy_policy_title": "Informativa sulla privacy",
    "privacy_policy_text": "Testo dell'informativa sulla privacy...",
    "first_time": "Nuovo sulla nostra piattaforma?",
    "registration": "Crea un account",
    "forgot_title": "Password dimenticata?",
    "forgot_description": "Inserisci la tua email e ti invieremo le istruzioni per reimpostare la password",
    "send_reset_link": "Invia link per il ripristino",
    "back_to_login": "Torna al login",
    "register": "Iscriviti",
    "name": "Nome",
    "last_name": "Cognome",
    "patronymic": "Patronimico",
    "phone": "Telefono",
    "enter_password": "Inserisci la Password",
    "confirm_password": "Conferma Password",
    "not_first_time": "Hai già un account?",
    "agree_too": "Accetto la",
    "privacy_policy": "politica sulla privacy & termini",
    "accept": " Accetto ",
    "password_validation": "Il campo deve contenere almeno una maiuscola, minuscola, carattere speciale e cifra con minimi 8 caratteri",
    "password_confirm_error": "La conferma del campo Password non corrisponde",
    "set_password": "Imposta Nuova Password",
    "reset_password": "Reimposta Password",
    "for": "per",
    "sign_in_to_for": "Accedi a {app} per {org}",
    "registration_title": "Registrazione",
    "verify_title": "Conferma email",
    "verify_head": "Verifica il tuo email",
    "verify_description": "Un link di attivazione è stato inviato alla tua email. Segui il link all'interno per continuare.",
    "verify_new_link": "Un nuovo link di verifica è stato inviato all'indirizzo email che hai fornito durante la registrazione.",
    "verify_send": "Invia nuovamente l'email di verifica",
    "verify_spam": "Hai effettuato troppe richieste, riprova tra un minuto",
    "verify_logout": "Esci",
    "two_factor_title": "Autenticazione a due fattori",
    "two_factor_description_email": "Abbiamo inviato un codice di verifica al tuo indirizzo email. Per favore inserisci il codice qui sotto.",
    "two_factor_description_sms": "Abbiamo inviato un codice di verifica al tuo numero di telefono. Per favore inserisci il codice qui sotto.",
    "two_factor_code_label": "Codice di verifica",
    "two_factor_code_placeholder": "Inserisci il codice a 6 cifre",
    "two_factor_verify": "Verifica",
    "two_factor_resend": "Reinvia codice",
    "two_factor_resend_success": "È stato inviato un nuovo codice",
    "two_factor_back": "Torna al login"
  },
  "filepond": {
    "upload": "Carica",
    "upload_complete": "Caricamento completato",
    "uploading": "Caricamento",
    "loading": "Caricamento",
    "tap_to_cancel": "tocca per annullare",
    "tap_to_undo": "tocca per annullare",
    "upload_aborted": "Caricamento annullato",
    "file_too_large": "Il file è troppo grande"
  },
  "text-editor": {
    "image": "Simply drag and drop your image in editor"
  },
  "webrtc": {
    "ready_to_start": "Pronto per iniziare",
    "connected": "Connesso - Parla ora!",
    "connection_lost": "Connessione persa. Per favore riprova."
  },
  "device_settings": {
    "title": "Impostazioni Dispositivi Audio e Video",
    "speaker": "Altoparlante/Uscita Audio",
    "refresh_devices": "Aggiorna Dispositivi",
    "speaker_switch_unsupported": "Il cambio dell'altoparlante non è supportato in questo browser"
  },
  "device_setup": {
    "mic_level": "Livello microfono",
    "mic_on": "On",
    "mic_off": "Off",
    "cam_on": "On",
    "cam_off": "Off"
  },
  "device_test": {
    "title": "Testa Dispositivi Audio",
    "speaker_test": "Test Altoparlante",
    "speaker_hint": "Clicca il pulsante per riprodurre suoni di test attraverso l'altoparlante selezionato",
    "play_sound": "Riproduci Suono Test",
    "playing": "Riproduzione...",
    "speaker_success": "Suono Riprodotto ✓",
    "mic_test": "Test Microfono",
    "mic_hint": "Clicca il pulsante e parla nel microfono per verificare se funziona",
    "volume_level": "Livello Volume",
    "speak_now": "Parla ora...",
    "seconds_short": "s",
    "start_mic_test": "Testa Microfono",
    "testing": "Test in corso...",
    "test_again": "Testa di Nuovo",
    "mic_success": "Il microfono funziona correttamente!",
    "mic_fail": "Rilevato problema con il microfono",
    "mic_fail_hint": "Nessun suono rilevato. Verifica che il microfono sia collegato, non silenziato e selezionato correttamente nelle impostazioni."
  },
  "ai_assistant_types": {
    "type": "Tipo",
    "negotiation": "Negoziazione",
    "feedback": "Feedback",
    "ai_profile": "Sessione con IA"
  },
  "Login": "Accesso",
  "UI Elements": "Elementi UI",
  "Forms & Tables": "Form e Tabelle",
  "Welcome": "Benvenuto",
  "Pages": "Pagine",
  "Charts & Maps": "Grafici e Mappe",
  "Others": "Altri",
  "Typography": "Tipografia",
  "Cards": "Carte",
  "Basic": "Base",
  "Advance": "Avanzato",
  "Widgets": "Widget",
  "Components": "Componenti",
  "Alert": "Allerta",
  "Close Alert": "Chiudi Allerta",
  "Avatar": "Avatar",
  "Badge": "Distintivo",
  "Button": "Pulsante",
  "Calendar": "Calendario",
  "Image": "Immagine",
  "Pagination": "Paginazione",
  "Progress Circular": "Progresso Circolare",
  "Progress Linear": "Progresso Lineare",
  "Autocomplete": "Autocompletamento",
  "Tooltip": "Suggerimento",
  "Slider": "Slider",
  "Date Time Picker": "Selettore di Data e Ora",
  "Select": "Seleziona",
  "Switch": "Interruttore",
  "Checkbox": "Casella di controllo",
  "Radio": "Radio",
  "Textarea": "Area di testo",
  "Rating": "Valutazione",
  "File Input": "Input file",
  "Otp Input": "Input Otp",
  "Form Layout": "Layout del modulo",
  "Form Validation": "Validazione del modulo",
  "Charts": "Grafici",
  "Apex Chart": "Grafico Apex",
  "Chartjs": "Grafico js",
  "Account Settings": "Impostazioni Account",
  "User Profile": "Profilo Utente",
  "FAQ": "FAQ",
  "Dialog Examples": "Esempi di Dialoghi",
  "Pricing": "Prezzi",
  "List": "Elenco",
  "Edit": "Modifica",
  "Nav Levels": "Livelli di Navigazione",
  "Level 2.1": "Livello 2.1",
  "Level 2.2": "Livello 2.2",
  "Level 3.1": "Livello 3.1",
  "Level 3.2": "Livello 3.2",
  "Raise Support": "Richiedi Supporto",
  "Documentation": "Documentazione",
  "Dashboards": "Dashboard",
  "Analytics": "Analisi",
  "Apps & Pages": "App e Pagine",
  "Email": "Email",
  "Chat": "Chat",
  "Invoice": "Fattura",
  "Preview": "Anteprima",
  "Add": "Aggiungi",
  "User": "Utente",
  "View": "Visualizza",
  "Login v1": "Login v1",
  "Login v2": "Login v2",
  "Register v1": "Registrati v1",
  "Register v2": "Registrati v2",
  "Register": "Registrati",
  "Forget Password v1": "Forgot Password v1",
  "Forget Password v2": "Forgot Password v2",
  "Forgot Password v1": "Forgot Password v1",
  "Forgot Password v2": "Forgot Password v2",
  "Forgot Password": "Password dimenticata",
  "Reset Password v1": "Reimposta Password v1",
  "Reset Password v2": "Reimposta Password v2",
  "Reset Password": "Reimposta Password",
  "Miscellaneous": "Varie",
  "Coming Soon": "In Arrivo",
  "Not Authorized": "Non Autorizzato",
  "Under Maintenance": "In Manutenzione",
  "Error": "Errore",
  "Statistics": "Statistiche",
  "Actions": "Azioni",
  "Access Control": "Controllo Accessi",
  "User Interface": "Interfaccia Utente",
  "CRM": "CRM",
  "eCommerce": "eCommerce",
  "Icons": "Icone",
  "Chip": "Chip",
  "Dialog": "Dialogo",
  "Expansion Panel": "Pannello di espansione",
  "Combobox": "Casella combinata",
  "Textfield": "Campo di testo",
  "Range Slider": "Slider di intervallo",
  "Menu": "Menu",
  "Snackbar": "Snackbar",
  "Tabs": "Schede",
  "Form Elements": "Elementi del modulo",
  "Form Layouts": "Layout del modulo",
  "Authentication": "Autenticazione",
  "Page Not Found - 404": "Pagina Non Trovata - 404",
  "Not Authorized - 401": "Non Autorizzato - 401",
  "Server Error - 500": "Errore del Server - 500",
  "2": "2",
  "Forms": "Moduli",
  "Timeline": "Linea Temporale",
  "Disabled Menu": "Menu Disabilitato",
  "Help Center": "Centro Assistenza",
  "Verify Email": "Verifica Email",
  "Verify Email v1": "Verifica Email v1",
  "Verify Email v2": "Verifica Email v2",
  "Two Steps": "Due Passi",
  "Two Steps v1": "Due Passi v1",
  "Two Steps v2": "Due Passi v2",
  "Custom Input": "Input Personalizzato",
  "Extensions": "Estensioni",
  "Tour": "Tour",
  "Register Multi-Steps": "Registrazione Multi-Step",
  "Wizard Examples": "Esempi Wizard",
  "Checkout": "Checkout",
  "Create Deal": "Crea Offerta",
  "Property Listing": "Annuncio Immobiliare",
  "Roles & Permissions": "Ruoli & Permessi",
  "Roles": "Ruoli",
  "Simple Table": "Tabella Semplice",
  "Tables": "Tabelle",
  "Data Table": "Tabella Dati",
  "Permissions": "Permessi",
  "Apps": "App",
  "Misc": "Varie",
  "Wizard Pages": "Pagine Wizard",
  "Form Wizard": "Wizard Modulo",
  "Numbered": "Numerato",
  "3": "3",
  "ecommerce": "ecommerce",
  "Ecommerce": "Ecommerce",
  "Editors": "Editori",
  "Front Pages": "Pagine di Front",
  "Landing": "Landing",
  "checkout": "checkout",
  "Payment": "Pagamento",
  "Swiper": "Swiper",
  "Product": "Prodotto",
  "Category": "Categoria",
  "Order": "Ordine",
  "Details": "Dettagli",
  "Customer": "Cliente",
  "Manage Review": "Gestione Recensioni",
  "Referrals": "Riferimenti",
  "Settings": "Impostazioni",
  "Overview": "Panoramica",
  "My Course": "Il Mio Corso",
  "Course Details": "Dettagli Corso",
  "Academy": "Accademia",
  "Logistics": "Logistica",
  "Dashboard": "Cruscotto",
  "Fleet": "Flotta",
  "5": "5",
  "10": "10",
  "20": "20",
  "25": "25",
  "50": "50",
  "100": "100",
  "maintenance": "Manutenzione",
  "maintenance-page": {
    "title": "Impostazioni di manutenzione",
    "notification_section": "Notifica globale",
    "notification_placeholder": "Inserisci il messaggio di notifica per tutti gli utenti",
    "notification_hint": "Questo messaggio verrà mostrato a tutti gli utenti autenticati come avviso",
    "games_section": "Blocco sessioni",
    "games_blocked_label": "Blocca nuove sessioni",
    "games_blocked_hint": "Quando attivato, gli utenti non possono creare o avviare nuove sessioni. Le sessioni esistenti possono ancora essere raggiunte.",
    "save": "Salva",
    "clear": "Cancella",
    "clear_confirm": "Sei sicuro di voler cancellare la notifica?",
    "last_updated": "Ultimo aggiornamento",
    "updated_by": "da",
    "games_blocked_message": "Ci scusiamo per l'inconveniente. La piattaforma è attualmente in manutenzione. Le sessioni sono temporaneamente non disponibili."
  },
  "$vuetify": {
    "badge": "Distintivo",
    "noDataText": "Nessun data disponibile",
    "close": "Chiudi",
    "open": "apri",
    "carousel": {
      "ariaLabel": {
        "delimiter": "delimitatore"
      }
    },
    "dataFooter": {
      "itemsPerPageText": "Elementi per pagina:",
      "itemsPerPageAll": "Tutti",
      "pageText": "{0}-{1} di {2}",
      "firstPage": "Prima Pagina",
      "prevPage": "Pagina Precedente",
      "nextPage": "Pagina Successiva",
      "lastPage": "Ultima Pagina"
    },
    "pagination": {
      "ariaLabel": {
        "root": "radice",
        "previous": "precedente",
        "next": "successiva",
        "first": "prima",
        "last": "ultima",
        "currentPage": "pagina_corrente",
        "page": "pagina"
      }
    },
    "input": {
      "clear": "cancella",
      "appendAction": "aggiungiAzione",
      "prependAction": "preapponiAzione",
      "counterSize": "dimensioneContatore",
      "otp": "otp"
    },
    "fileInput": {
      "counterSize": "dimensioneContatore"
    },
    "rating": {
      "ariaLabel": {
        "item": "articolo"
      }
    }
  },
  "skill_reports": {
    "skill_development_report": "Rapporto di sviluppo delle competenze",
    "generate": "Genera",
    "generate_description": "Genera un rapporto completo di sviluppo delle competenze per un periodo selezionato",
    "manager_description": "Genera rapporti di sviluppo delle competenze per i dipendenti della tua organizzazione",
    "date": "Data",
    "competence": "Competenza",
    "period": "Periodo",
    "status_label": "Stato",
    "actions": "Azioni",
    "employee": "Dipendente",
    "view": "Visualizza rapporto",
    "download_pdf": "Scarica PDF",
    "no_reports": "Nessun rapporto generato finora",
    "data_not_available": "I dati del rapporto non sono ancora disponibili",
    "generation_failed": "Generazione del rapporto fallita",
    "retry": "Riprova",
    "rate_limit_exceeded": "Limite di generazione dei rapporti raggiunto. Riprova più tardi.",
    "too_many_pending": "Hai troppi rapporti in corso. Attendi il loro completamento.",
    "no_games_for_report": "Nessuna sessione completata trovata per il periodo e la competenza selezionati. Il rapporto non può essere generato.",
    "report_already_exists": "Un rapporto con questi parametri esiste già. Controlla l'elenco qui sotto.",
    "period_too_long": "Il periodo del rapporto non deve superare un anno.",
    "invalid_parameters": "Controlla la competenza e il periodo",
    "filter_by_employee": "Filtra per dipendente...",
    "batch": {
      "mode_single": "Report singolo",
      "mode_batch": "Lotto",
      "load_employees": "Mostra dipendenti",
      "sessions": "Sessioni",
      "no_candidates": "Nessun dipendente con sessioni completate per la competenza e il periodo selezionati",
      "generate_selected": "Genera ({count})",
      "selected_limit": "Puoi selezionare al massimo {max} dipendenti alla volta",
      "progress": "{ready} di {total} pronti",
      "failed_count": "Errori: {count}",
      "status_unknown": "Stato sconosciuto",
      "status_unknown_hint": "Il report non è stato trovato nell'elenco: controlla la tabella dei report qui sotto",
      "reused": "Report riutilizzati: {count} — generati nelle ultime {hours} h e non ricreati",
      "reused_badge": "Riutilizzato",
      "reused_on": "Generato il {date}",
      "download_all": "Scarica tutto",
      "toggle_details": "Mostra il contenuto del lotto",
      "dismiss_confirm": "Questo lotto è ancora in generazione. Rimuoverlo dallo schermo? Lo stato di avanzamento e il pulsante «Scarica tutto» andranno persi; i report restano nell'elenco qui sotto.",
      "archive_unavailable": "Impossibile creare l'archivio: alcuni report non sono ancora pronti o non sono più disponibili",
      "archive_failed": "Impossibile scaricare l'archivio",
      "archive_building": "Creazione dell'archivio…",
      "archive_build_failed": "Impossibile creare l'archivio. Riprova.",
      "candidates_failed": "Impossibile caricare l'elenco dei dipendenti",
      "stale_selection": "Alcuni dipendenti selezionati non sono più disponibili. L'elenco è stato aggiornato: selezionali di nuovo."
    },
    "quota": {
      "remaining_hour": "Limite di rapporti: {limit} all'ora. Puoi richiederne ancora {remaining} in questo momento. Seleziona meno dipendenti o riprova alle {time}.",
      "remaining_day": "Limite di rapporti: {limit} al giorno. Puoi richiederne ancora {remaining} in questo momento. Seleziona meno dipendenti o riprova alle {time}.",
      "exhausted_hour": "Limite di rapporti raggiunto ({limit} all'ora). Sarà ripristinato alle {time}.",
      "exhausted_day": "Limite di rapporti raggiunto ({limit} al giorno). Sarà ripristinato alle {time}.",
      "too_large_hour": "Limite di rapporti: {limit} all'ora. Seleziona meno dipendenti.",
      "too_large_day": "Limite di rapporti: {limit} al giorno. Seleziona meno dipendenti."
    },
    "status": {
      "pending": "In attesa",
      "collecting_data": "Raccolta dati...",
      "analyzing": "Analisi IA...",
      "generating_pdf": "Generazione PDF...",
      "ready": "Pronto",
      "failed": "Fallito"
    },
    "report": {
      "kicker": "Rapporto di sviluppo di una competenza",
      "position": "Posizione",
      "department": "Dipartimento",
      "period": "Periodo",
      "games_count": "Sessioni svolte",
      "not_specified_f": "Non specificata",
      "not_specified_n": "Non specificato",
      "fig": {
        "your_average": "Il tuo punteggio medio",
        "company_average": "Media aziendale",
        "participants": "Partecipanti nel periodo",
        "skills_count": "Abilità valutate"
      },
      "sec": {
        "profile": "Profilo della competenza",
        "trend": "Andamento per sessione",
        "strengths": "Su cosa fare leva",
        "priorities": "Tre priorità di sviluppo",
        "skills": "Analisi per abilità",
        "plan": "Piano di tre mesi"
      },
      "legend": {
        "you": "Il tuo punteggio",
        "company": "Media aziendale"
      },
      "dotplot_caption": "Scarto dalla media — dal maggior vantaggio al maggior ritardo",
      "trend_disclaimer": "I punteggi delle sessioni non sono direttamente confrontabili: la difficoltà dei casi varia da una sessione all'altra. Un calo non significa di per sé un arretramento dell'abilità: il grafico è un'osservazione, non un giudizio.",
      "no_comparison": "Il confronto con la media aziendale non è disponibile: nel periodo meno di tre persone hanno svolto sessioni su questa competenza. Il rapporto si basa sui punteggi assoluti.",
      "skill": {
        "works": "Cosa funziona",
        "blocks": "Cosa ostacola",
        "actions": "Cosa fare",
        "out_of_ten": "su 10",
        "company_short": "azienda"
      },
      "level": {
        "outstanding": "Risultato eccellente",
        "strength": "Punto di forza",
        "meets_standard": "In linea con l'azienda",
        "needs_attention": "Richiede attenzione",
        "needs_development": "Area di sviluppo"
      },
      "plan": {
        "month": "Mese",
        "goals": "Obiettivi",
        "actions": "Azioni"
      },
      "colophon": {
        "built_on": "Il rapporto si basa sulle sessioni del periodo {from} — {to}. Sessioni totali: {count}.",
        "comparison": "Il confronto è con la media aziendale dello stesso periodo. Partecipanti: {count}."
      }
    }
  },
    "api-tokens": "Token API",
    "api-tokens-page": {
        "select_user": "Utente",
        "select_user_hint": "Seleziona un utente per visualizzare e gestire i suoi token API.",
        "no_users_found": "Nessun utente trovato",
        "no_tokens": "Questo utente non ha token API.",
        "token_name": "Nome",
        "abilities": "Autorizzazioni",
        "ability": "Autorizzazione",
        "created_at": "Creato il",
        "last_used_at": "Ultimo utilizzo",
        "expires_at": "Scade il",
        "actions": " ",
        "issue_token": "Emetti token",
        "issue": "Emetti",
        "issue_failed": "Emissione del token non riuscita",
        "token": "Token",
        "plaintext_warning": "Copia questo token adesso — non verrà più mostrato.",
        "revoke": "Revoca",
        "revoke_confirm": "Sei sicuro di voler revocare questo token? Le integrazioni che lo utilizzano smetteranno di funzionare."
    },
  "subscription": {
    "current_plan": "Piano attuale",
    "expires_at": "Scade il: {date}",
    "no_active_plan": "Nessun piano di abbonamento attivo",
    "quota_warning": "Quota rimanente bassa",
    "regular_games": "Sessioni regolari",
    "ai_games": "Sessioni IA",
    "any_games": "Qualsiasi sessione",
    "used_of": "{used} di {limit}",
    "remaining": "{count} rimanenti",
    "quota_exceeded": "Quota funzionalità superata",
    "tickets_only": "Pacchetti crediti",
    "session_package": "Pacchetto sessioni",
    "games_available": "Sessioni",
    "users": "Utenti",
    "active_users": "Utenti attivi",
    "active_tickets": "Pacchetti crediti",
    "ticket_charges": "{charges} crediti",
    "ticket_no_expiry": "Senza scadenza",
    "unlimited": "Illimitato",
    "no_game_limits": "Nessuna restrizione sul numero di sessioni"
  },
  "knowledge-base-page": {
    "provider-unsupported": "La knowledge base non è disponibile con l'attuale fornitore AI della tua organizzazione."
  },
  "candidate-page": {
    "document_title": "Colloquio",
    "greeting": "Salve, {name}!",
    "intro_lead": "{organization} La invita a un colloquio con un interlocutore virtuale per il ruolo di «{vacancy}».",
    "duration": "Il colloquio dura circa {minutes} min.",
    "requirements_title": "Cosa Le servirà",
    "requirement_mic": "Un microfono funzionante, idealmente delle cuffie con microfono",
    "requirement_camera_required": "Una telecamera accesa: per questo colloquio è obbligatoria",
    "requirement_camera_optional": "La telecamera è facoltativa, ma con essa la conversazione risulta più naturale",
    "requirement_browser": "Un computer con una versione aggiornata di Chrome, Edge o Safari",
    "requirement_network": "Una connessione stabile e un luogo tranquillo dove nessuno La interromperà",
    "continue": "Continua",
    "consent": {
      "accept": "Ho letto il testo e acconsento al trattamento dei miei dati personali",
      "back": "Indietro",
      "start": "Inizia il colloquio"
    },
    "terminal": {
      "finished": {
        "title": "Grazie!",
        "text": "Il colloquio è terminato e il risultato è stato inviato al recruiter, che La contatterà. Può chiudere questa pagina."
      },
      "already_completed": {
        "title": "Colloquio già completato",
        "text": "Questo link è già stato utilizzato per un colloquio completato. Se deve ripeterlo, contatti il recruiter."
      },
      "not_found": {
        "title": "Link non trovato",
        "text": "L'indirizzo potrebbe contenere un errore di battitura, oppure il link non è più valido. Controlli l'email del recruiter o lo contatti."
      },
      "session_conflict": {
        "title": "Ha eseguito l'accesso con un altro account",
        "text": "Esca dall'account corrente oppure apra il link in una finestra privata del browser."
      },
      "link_revoked": {
        "title": "L'accesso a questo link è stato chiuso",
        "text": "Il recruiter ha revocato questo link. Lo contatti per riceverne uno nuovo."
      },
      "link_expired": {
        "title": "Il link è scaduto",
        "text": "Contatti il recruiter per farsi inviare un nuovo link."
      },
      "attempts_exhausted": {
        "title": "Nessun tentativo rimasto",
        "text": "Tutti i tentativi disponibili per questo link sono stati utilizzati. Contatti il recruiter."
      },
      "unavailable": {
        "title": "Al momento non è possibile iniziare",
        "text": "Riprovi più tardi oppure contatti il recruiter."
      },
      "rate_limited": {
        "title": "Troppi tentativi",
        "text": "Attenda un minuto e ricarichi la pagina."
      },
      "aborted": {
        "title": "Il colloquio non è iniziato",
        "text": "Ricarichi la pagina e riprovi. Se il problema persiste, contatti il recruiter."
      },
      "generic": {
        "title": "Qualcosa è andato storto",
        "text": "Ricarichi la pagina e riprovi. Se il problema persiste, contatti il recruiter."
      }
    }
  },
  "recruiting-page": {
    "title": "Reclutamento",
    "create": "Nuova posizione aperta",
    "edit": "Modifica posizione aperta",
    "empty": "Nessuna posizione aperta per ora",
    "load_error": "Impossibile caricare l'elenco delle posizioni aperte",
    "retry": "Riprova",
    "back": "Torna alle posizioni aperte",
    "open": "Candidati",
    "archive": "Archivia",
    "no_expiry": "Senza scadenza",
    "confirm_archive": "Archiviare questa posizione aperta? Non sarà più possibile emettere link per essa.",
    "headers": {
      "title": "Posizione",
      "scenario": "Scenario",
      "status": "Stato",
      "expires_at": "Scade il",
      "actions": "Azioni"
    },
    "status": {
      "draft": "Bozza",
      "active": "Attiva",
      "archived": "Archiviata"
    },
    "dialog": {
      "title_label": "Titolo della posizione aperta",
      "scenario_label": "Scenario del colloquio",
      "scenario_placeholder": "Scegli uno scenario per il colloquio con l'IA",
      "scenario_hint": "Sono elencati solo gli scenari adatti a una sessione contro IA",
      "status_label": "Stato",
      "expires_label": "Valida fino al",
      "expires_hint": "Lascia vuoto per nessuna scadenza",
      "save": "Salva",
      "cancel": "Annulla"
    },
    "messages": {
      "created": "Posizione aperta creata",
      "updated": "Posizione aperta aggiornata",
      "archived": "Posizione aperta archiviata",
      "revoked": "Link revocato",
      "attempt_granted": "Concesso un altro tentativo",
      "copied": "Link copiato",
      "error": "Qualcosa è andato storto"
    },
    "candidates": {
      "title": "Candidati",
      "empty": "Per questa posizione aperta non è ancora stato emesso nessun link",
      "load_error": "Impossibile caricare l'elenco dei candidati",
      "issue": "Emetti un link",
      "import": "Importa da file",
      "expired": "Scaduto",
      "no_games": "Colloquio non iniziato",
      "attempts": "{used} di {allowed}",
      "revoke": "Revoca il link",
      "extra_attempt": "Concedi un altro tentativo",
      "open_result": "Apri il risultato del colloquio",
      "confirm_revoke": "Revocare il link di questo candidato? L'accesso viene perso subito, incluso un eventuale colloquio in corso.",
      "confirm_extra_attempt": "Concedere a questo candidato un altro tentativo?",
      "headers": {
        "candidate": "Candidato",
        "link_status": "Link",
        "invite": "Invito",
        "game_status": "Colloquio",
        "attempts": "Tentativi",
        "expires_at": "Scade il",
        "actions": "Azioni"
      },
      "link_status": {
        "created": "Emesso",
        "opened": "Aperto",
        "in_progress": "Colloquio in corso",
        "completed": "Colloquio completato",
        "revoked": "Revocato"
      },
      "invite_status": {
        "not_sent": "Non inviato",
        "queued": "In coda",
        "sent": "Inviato",
        "failed": "Invio fallito"
      },
      "invite_sent_at": "Email accettata dal servizio di posta il {date}",
      "invite_failure": {
        "rejected": "Il servizio di posta ha rifiutato l'email: invia tu il link al candidato",
        "transport": "Invio fallito: invia tu il link al candidato",
        "revoked": "Il link è stato revocato",
        "sending_disabled": "L'invio delle email è disattivato",
        "blocked": "L'indirizzo è nella lista di blocco: invia tu il link al candidato"
      }
    },
    "issue_dialog": {
      "title": "Emetti un link personale",
      "name": "Nome",
      "last_name": "Cognome",
      "email": "Email",
      "phone": "Telefono",
      "attempts": "Tentativi consentiti",
      "expires_at": "Link valido fino al",
      "expires_hint": "Lascia vuoto per ereditare la scadenza della posizione aperta",
      "submit": "Emetti il link",
      "close": "Chiudi",
      "result_title": "Link emesso",
      "warning": "Copia il link adesso: viene mostrato esattamente una volta. Nel database è salvato solo il suo hash, quindi il link non può essere recuperato: quello perso va revocato ed emesso di nuovo.",
      "copy": "Copia",
      "copied": "Copiato",
      "send_invite": "Invia un invito a {email}",
      "send_invite_no_email": "Invia un invito via email",
      "send_invite_blocked": "Questo indirizzo è nella lista di blocco: l'email non verrà inviata",
      "invite_queued": "Invito messo in coda per {email}",
      "invite_blocked": "Invito non inviato: {email} è nella lista di blocco. Invia tu il link al candidato"
    },
    "import_dialog": {
      "title": "Importa candidati",
      "subtitle": "Ogni riga del file diventa un candidato e un link personale.",
      "file": "File con l'elenco dei candidati",
      "columns": "Colonne: Nome, Cognome, Email, Telefono",
      "limits": "xlsx o CSV con «;», fino a 200 righe e 10 MB",
      "size_error": "Il file supera i 10 MB",
      "download_example": "Scarica esempio",
      "note_title": "I link sono visibili solo nel file scaricato",
      "note_text": "Il file si scarica non appena l'importazione termina. Nel database sono salvati solo gli hash dei link: non è possibile esportarli una seconda volta, conserva il file.",
      "submit": "Importa",
      "cancel": "Annulla",
      "result_title": "Link emessi",
      "result": "Link emessi: {count}. Il file è stato scaricato.",
      "invites_blocked": "Inviti non inviati: {count}. Questi indirizzi sono nella lista di blocco: invia tu i link a questi candidati.",
      "saved_title": "Conserva il file scaricato",
      "saved_text": "È l'unica copia di questi link: nel database sono salvati solo i loro hash. Un link perso può solo essere revocato ed emesso di nuovo.",
      "download_again": "Scarica di nuovo il file",
      "errors_title": "Righe rifiutate",
      "error_row": "Riga {row}: {error}",
      "errors_truncated": "…e altre {count} righe rifiutate. Sopra sono elencate le prime 50.",
      "send_invites": "Invia gli inviti via email ai candidati",
      "send_invites_hint": "I candidati senza indirizzo email non ne riceveranno"
    }
  },
  "ai-reports": "Report IA",
  "ai-reports-page": {
    "title": "Report IA",
    "subtitle": "Descrivi il report con parole tue: costruiamo la specifica, mostriamo un'anteprima e la esportiamo in Excel.",
    "status": {
      "draft": "Bozza",
      "pending": "In generazione",
      "ready": "Pronto",
      "failed": "Generazione non riuscita"
    },
    "list": {
      "title": "I miei report",
      "new": "Nuovo report",
      "empty": "Ancora nessun report. Fai clic su «Nuovo report» e descrivi cosa mostrare.",
      "untitled": "Senza titolo",
      "delete": "Elimina report",
      "delete_confirm": "Eliminare il report insieme al file generato?",
      "deleted": "Report eliminato"
    },
    "dialog": {
      "title": "Dialogo",
      "open_dictionary": "Catalogo dati",
      "placeholder": "Ad esempio: quante partite ha svolto ogni reparto nell'ultimo trimestre",
      "send": "Invia",
      "empty_title": "Cosa deve mostrare il report?",
      "empty_text": "Scrivilo con parole semplici: quali dati, per quale periodo e con quale ripartizione. Se manca qualcosa, te lo chiederò.",
      "examples_title": "Ad esempio:",
      "examples": {
        "e1": "Quante partite ha svolto ogni reparto nell'ultimo trimestre",
        "e2": "Punteggio medio delle competenze nel reparto vendite per il 2026",
        "e3": "Dipendenti che non giocano da più di un mese",
        "e4": "Candidati per posizione e stato del link negli ultimi 30 giorni"
      },
      "thinking": "Generazione del report…",
      "waiting_hint": "La risposta comparirà qui da sola: non serve aggiornare la pagina.",
      "retry": "Riprova",
      "dismiss": "Nascondi",
      "spec_ready": "Il report è pronto: controlla l'anteprima qui sotto e genera il file.",
      "stuck_title": "Sembra che stiamo girando in tondo",
      "stuck_text": "Consulta il catalogo dati e riformula la richiesta usando i suoi termini: è più rapido che rispondere a un'altra domanda di chiarimento.",
      "rejected_title": "Questo report non può ancora essere generato",
      "reason": {
        "no_such_measure": "Questa misura non esiste nei nostri dati. Controlla l'elenco delle misure nel catalogo.",
        "no_such_field": "Questo campo non esiste nei nostri dati. Controlla l'elenco dei campi nel catalogo.",
        "cross_dataset": "La richiesta necessita di dati provenienti da due insiemi di dati contemporaneamente. Dividila in due report.",
        "window_function": "Le quote sul totale, le posizioni in classifica e il confronto con il periodo precedente non sono ancora supportati.",
        "other": "La richiesta va oltre i dati disponibili. Consulta il catalogo e prova un'altra formulazione."
      },
      "usage": {
        "employees": "nessun dipendente | {n} dipendente | {n} dipendenti",
        "games": "nessuna partita | {n} partita | {n} partite",
        "scenarios": "nessuno scenario | {n} scenario | {n} scenari",
        "evaluations": "nessuna valutazione | {n} valutazione | {n} valutazioni",
        "candidates": "nessun candidato | {n} candidato | {n} candidati"
      },
      "option_created_at": "aggiunta: {date}"
    },
    "preview": {
      "title": "Anteprima",
      "no_report": "Scegli un report a sinistra o avviane uno nuovo.",
      "no_spec": "Descrivi il report nel dialogo: l'anteprima comparirà non appena la richiesta sarà stata compresa.",
      "spec_title": "Cosa conterrà il report",
      "rows_hint": "Vengono mostrate le prime {count} righe",
      "total": "Righe totali: {count}",
      "zero_rows": "Questa richiesta non restituisce alcuna riga. Amplia il periodo o rimuovi i filtri: non ha senso generare un file vuoto.",
      "zero_rows_hint": "Controlla i valori dei filtri: potrebbero non esserci dati per essi",
      "duplicate_rows": "Alcune righe dell’anteprima sono identiche: le colonne scelte non distinguono i record di questo insieme di dati. Verifica che cosa significhi davvero una riga qui: potrebbe mancare una colonna che le differenzi.",
      "too_many_rows": "Il report contiene {count} righe, il massimo è {max}. Restringi il periodo o aggiungi filtri: oltre il limite il file non viene generato affatto, non troncato.",
      "generate": "Genera file",
      "regenerate": "Rigenera",
      "queued": "Il file è in generazione: la scheda si aggiornerà da sola quando sarà pronto.",
      "failed": "Non è stato possibile generare il report",
      "download": "Scarica .xlsx",
      "downloads": "Download: {count}",
      "ttl_warning": "Il file viene conservato per {days} giorni e poi eliminato: scaricalo subito.",
      "expires_at": "Disponibile fino al {date}",
      "expired": "Il file è stato eliminato alla scadenza del periodo di conservazione: genera di nuovo il report."
    },
    "spec": {
      "dataset": "Dati",
      "columns": "Colonne",
      "measures": "Misure",
      "group_by": "Ripartizione",
      "period": "Periodo",
      "period_value": "{field}: dal {from} al {to}",
      "period_all": "Tutto il periodo disponibile",
      "filters": "Filtri",
      "having": "Condizioni sulle misure",
      "sort": "Ordinamento",
      "limit": "Limite di righe",
      "limit_value": "prime {count} righe",
      "granularity": {
        "year": "per anno",
        "quarter": "per trimestre",
        "month": "per mese",
        "week": "per settimana",
        "day": "per giorno",
        "dow": "per giorno della settimana"
      },
      "dir": {
        "asc": "crescente",
        "desc": "decrescente"
      },
      "filter": {
        "equals": "{field} — {value}",
        "not_equals": "{field} — diverso da {value}",
        "in": "{field} — uno tra: {value}",
        "not_in": "{field} — tranne: {value}",
        "gt": "{field} maggiore di {value}",
        "gte": "{field} almeno {value}",
        "lt": "{field} minore di {value}",
        "lte": "{field} al massimo {value}",
        "contains": "{field} contiene «{value}»",
        "between": "{field} — dal {from} al {to}",
        "is_null": "{field} non compilato",
        "is_not_null": "{field} compilato"
      }
    },
    "value": {
      "yes": "Sì",
      "no": "No"
    },
    "dictionary": {
      "title": "Catalogo dati",
      "subtitle": "Tutto ciò che può essere incluso in un report. L'elenco è live: è lo stesso da cui viene costruita la specifica.",
      "fields": "Campi",
      "measures": "Misure",
      "values": "Valori",
      "show_values": "Mostra i valori della tua organizzazione",
      "hide_values": "Nascondi i valori",
      "values_error": "Non è stato possibile caricare i valori: riprova.",
      "values_empty": "La tua organizzazione non ha ancora valori per questo campo.",
      "limits": {
        "title": "Cosa un report non può fare",
        "pivot": "Una tabella pivot con una colonna per ogni partecipante o per ogni domanda non verrà creata. Chiedi invece la forma lunga: una riga per ogni coppia partecipante-domanda.",
        "window": "Il report non calcola la variazione mese su mese, la quota sul totale, la posizione in classifica né «i primi tre di ogni dipartimento». Prendi la ripartizione per mese e completa il calcolo in Excel.",
        "missing": "Quello che il sistema non memorizza non comparirà nel report: stipendi, NPS e altri dati custoditi altrove non compariranno sotto nessun nome."
      },
      "empty": "Il catalogo è vuoto: contatta il tuo amministratore.",
      "close": "Chiudi"
    },
    "errors": {
      "generic": "Qualcosa è andato storto. Riprova.",
      "detail": "Non compreso: {value}",
      "rate_limit": "Troppe richieste. Attendi un minuto e riprova.",
      "download": "Impossibile scaricare il file.",
      "turn_failed": "Non è stato possibile ottenere la risposta. Invia di nuovo la richiesta.",
      "turn_stuck_in_queue": "La richiesta non è mai stata elaborata: ha atteso troppo a lungo in coda. Inviala di nuovo.",
      "unknown_resolution": "Questa opzione non è più valida: il report è cambiato nel frattempo. Riaprilo e precisa la richiesta."
    }
  },
    "externalLaunch": {
        "document_title": "Sessione di pratica",
        "intro": {
            "title": "Conversazione di pratica",
            "lead": "Sta per parlare con un interlocutore virtuale. La conversazione viene registrata e valutata, e il risultato tornerà al suo sistema di formazione.",
            "requirements_title": "Cosa Le servirà",
            "requirement_mic": "Un microfono funzionante, idealmente delle cuffie con microfono",
            "requirement_camera": "La telecamera è facoltativa, ma con essa la conversazione risulta più naturale",
            "requirement_browser": "Un computer con una versione aggiornata di Chrome, Edge o Safari",
            "requirement_network": "Una connessione stabile e un luogo tranquillo dove nessuno La interromperà",
            "start": "Inizia"
        },
        "relaunch_hint": "Torni al suo sistema di formazione e riapra il contenuto.",
        "saving": "Salvataggio del risultato…",
        "review": {
            "document_title": "Riepilogo della sessione",
            "attempt": "Tentativo {number}",
            "result": {
                "passed": "Superato",
                "failed": "Non superato",
                "pending": "Non ancora valutato"
            },
            "score_of_100": "{score} su 100",
            "threshold": "Soglia di superamento: {threshold}",
            "skills_title": "Competenze e raccomandazioni",
            "skills_empty": "Per questo tentativo non c'è ancora un riscontro per competenza.",
            "comments_title": "Commenti sulla registrazione",
            "comments_empty": "Non ci sono commenti su questa registrazione.",
            "loading": "Caricamento del riepilogo",
            "error": {
                "not_found": {
                    "title": "Il link non funziona",
                    "text": "Il riepilogo non è più disponibile: il link è scaduto o il tentativo è stato revocato."
                },
                "expired": {
                    "title": "La pagina è scaduta",
                    "text": "Riapra il riepilogo dal link nel suo sistema di formazione."
                },
                "generic": {
                    "title": "Impossibile mostrare il riepilogo",
                    "text": "Qualcosa è andato storto da parte nostra. Provi a riaprire il link."
                }
            }
        },
        "terminal": {
            "finished": {
                "title": "Grazie!",
                "text": "La conversazione è terminata. Il risultato comparirà nel suo sistema di formazione quando la valutazione sarà pronta. Può chiudere questa pagina."
            },
            "aborted": {
                "title": "La conversazione non è iniziata",
                "text": "Qualcosa è andato storto prima dell'inizio della conversazione."
            },
            "token_expired": {
                "title": "La sessione è scaduta",
                "text": "L'accesso a questa conversazione non è più valido."
            },
            "not_found": {
                "title": "Il link non funziona",
                "text": "L'indirizzo potrebbe contenere un errore, oppure il link non è più valido."
            },
            "rate_limited": {
                "title": "Troppi tentativi",
                "text": "Attenda un minuto prima di riprovare."
            },
            "generic": {
                "title": "Al momento non è possibile iniziare",
                "text": "Qualcosa è andato storto da parte nostra."
            }
        },
        "refusal": {
            "publication_disabled": {
                "title": "Il contenuto è chiuso",
                "text": "Questo contenuto non è più disponibile per la pratica."
            },
            "publication_draft": {
                "title": "Il contenuto non è ancora pubblicato",
                "text": "La pratica su questo contenuto non è ancora stata aperta."
            },
            "publication_expired": {
                "title": "Il contenuto è scaduto",
                "text": "Il periodo in cui era possibile fare pratica con questo contenuto è terminato."
            },
            "feature_disabled": {
                "title": "Il contenuto è chiuso",
                "text": "La pratica dal sistema di formazione è disattivata per la sua organizzazione."
            },
            "connection_disabled": {
                "title": "Il contenuto è chiuso",
                "text": "La connessione al suo sistema di formazione è disattivata. Contatti la persona che Le ha assegnato il corso."
            },
            "launch_limit_reached": {
                "title": "Il limite è stato raggiunto",
                "text": "Questo contenuto è già stato usato per il numero massimo di conversazioni."
            },
            "daily_budget_exhausted": {
                "title": "Per oggi può bastare",
                "text": "Ha raggiunto il numero di conversazioni consentite al giorno. Riprovi domani."
            },
            "attempts_exhausted": {
                "title": "Nessun tentativo rimasto",
                "text": "Ha usato tutti i tentativi consentiti per questo contenuto."
            },
            "quota_exhausted": {
                "title": "Al momento non è possibile iniziare",
                "text": "La sua organizzazione non ha più conversazioni disponibili. Contatti la persona che Le ha assegnato il corso."
            },
            "user_limit_reached": {
                "title": "Al momento non è possibile iniziare",
                "text": "La sua organizzazione non ha più posti liberi. Contatti la persona che Le ha assegnato il corso."
            },
            "scenario_unavailable": {
                "title": "Il contenuto non è disponibile",
                "text": "La conversazione collegata a questo contenuto non esiste più."
            },
            "assignment_check_unavailable": {
                "title": "Al momento non è possibile iniziare",
                "text": "Non abbiamo potuto confermare che questo contenuto Le sia assegnato. Contatti la persona che Le ha assegnato il corso."
            },
            "code_invalid": {
                "title": "Il link non è più valido",
                "text": "Questo link è già stato usato oppure il suo tempo è scaduto."
            },
            "channel_verification_failed": {
                "title": "Il sistema di formazione non ha risposto",
                "text": "Non abbiamo potuto confermare la richiesta con il suo sistema di formazione."
            },
            "external_system_unavailable": {
                "title": "Il sistema di formazione non risponde",
                "text": "Non abbiamo potuto verificare l'assegnazione del corso nel sistema di formazione. Riprovi tra qualche minuto."
            },
            "user_not_found": {
                "title": "Non siamo riusciti a identificarLa",
                "text": "Qui non esiste un account per Lei, e la sua organizzazione non li crea automaticamente. Contatti la persona che Le ha assegnato il corso."
            },
            "user_unavailable": {
                "title": "Il suo account è disattivato",
                "text": "Contatti la persona che Le ha assegnato il corso."
            },
            "user_deleted": {
                "title": "Il suo account è stato eliminato",
                "text": "Contatti la persona che Le ha assegnato il corso."
            },
            "email_taken_linking_disabled": {
                "title": "Non siamo riusciti a identificarLa",
                "text": "Il suo indirizzo email appartiene già a un altro account qui. Contatti la persona che Le ha assegnato il corso."
            },
            "service_role_not_allowed": {
                "title": "Con questo account non si può fare pratica",
                "text": "Gli account amministratore non partecipano alle conversazioni di pratica. Usi il suo account discente."
            },
            "unverified_request": {
                "title": "Non abbiamo potuto confermare la richiesta",
                "text": "Il suo sistema di formazione non ha confermato che questa conversazione sia stata avviata da Lei."
            }
        },
        "manage": {
            "nav": {
                "group": "Avvio esterno",
                "publications": "Pubblicazioni",
                "connections": "Connessioni LMS"
            },
            "messages": {
                "error": "Qualcosa è andato storto. Riprovare.",
                "load_error": "Impossibile caricare i dati."
            },
            "connections": {
                "title": "Connessioni LMS",
                "subtitle": "Account dei sistemi di formazione da cui questa organizzazione avvia la pratica.",
                "create": "Aggiungi connessione",
                "edit": "Modifica",
                "set_credentials": "Imposta credenziali",
                "empty": "Nessuna connessione per ora.",
                "secret_missing": "Non impostato",
                "no_expiry": "Non scade",
                "headers": {
                    "account": "Account",
                    "base_url": "Indirizzo",
                    "client_id": "ID client",
                    "secret": "Secret",
                    "status": "Stato",
                    "expires_at": "Scadenza credenziali",
                    "actions": " "
                },
                "status": {
                    "no_credentials": "Senza credenziali",
                    "active": "Attiva",
                    "expired": "Credenziali scadute",
                    "disabled": "Disattivata"
                },
                "lms": {
                    "ispring": "iSpring Learn"
                },
                "dialog": {
                    "create_title": "Nuova connessione",
                    "edit_title": "Connessione",
                    "immutable_hint": "Il sistema di formazione e l'account non si possono cambiare: definiscono lo spazio di identità dei discenti. Un account diverso è una nuova connessione.",
                    "lms_label": "Sistema di formazione",
                    "account_key_label": "Account",
                    "account_key_hint": "L'identificativo dell'account nel sistema di formazione.",
                    "base_url_label": "Indirizzo REST API iSpring",
                    "base_url_hint": "Ad esempio, https://api-learn.ispringlearn.ru. Non è l'indirizzo del portale dell'azienda: è l'indirizzo a cui viene inviato il secret.",
                    "base_url_https": "L'indirizzo deve iniziare con https://",
                    "enabled_label": "La connessione è attiva",
                    "enabled_hint": "Una connessione non viene mai eliminata, ma disattivata. Pubblicazioni e avvii restano negli elenchi, ma i nuovi avvii vengono rifiutati e i risultati non arrivano più al sistema di formazione.",
                    "credentials_optional": "Le credenziali sono facoltative. Senza di esse la connessione funziona in modalità limitata.",
                    "client_id_label": "ID client",
                    "secret_label": "Secret",
                    "secret_hint": "Viene memorizzato cifrato. Non può più essere riletto: sono visibili solo gli ultimi quattro caratteri.",
                    "expires_at_label": "Scadenza credenziali",
                    "expires_at_hint": "Lasciare vuoto se le credenziali non scadono."
                },
                "credentials_dialog": {
                    "title": "Credenziali",
                    "lead": "Il nuovo secret sostituisce quello precedente. La connessione mantiene il suo identificativo, e i link dei discenti e i loro avvii restano al loro posto.",
                    "secret_hint": "Il secret precedente non serve più e non può essere riletto."
                },
                "messages": {
                    "saved": "Connessione salvata",
                    "credentials_saved": "Credenziali salvate"
                }
            },
            "publications": {
                "title": "Pubblicazioni",
                "subtitle": "Scenari aperti all'avvio da un sistema di formazione.",
                "create": "Nuova pubblicazione",
                "edit": "Modifica",
                "enable": "Attiva",
                "disable": "Disattiva",
                "open_journal": "Registro",
                "download_package": "Scarica il pacchetto",
                "empty": "Nessuna pubblicazione per ora.",
                "no_connections": "Non c'è ancora una connessione a un sistema di formazione. La imposta un amministratore della piattaforma.",
                "no_expiry": "Nessuna scadenza",
                "attempts_unlimited": "Illimitati",
                "immutable_hint": "La connessione, lo scenario e il canale di consegna non si possono cambiare: sono integrati nel pacchetto già caricato nel sistema di formazione. Tutto il resto si applica senza doverlo ricostruire.",
                "headers": {
                    "scenario": "Scenario",
                    "connection": "Connessione",
                    "channel": "Canale",
                    "status": "Stato",
                    "settings": "Impostazioni",
                    "expires_at": "Scade",
                    "actions": " "
                },
                "summary": {
                    "attempts": "Tentativi: {value}",
                    "threshold": "Soglia: {value}"
                },
                "status": {
                    "draft": "Bozza",
                    "active": "Attiva",
                    "disabled": "Disattivata"
                },
                "channel": {
                    "scorm_1_2": "SCORM 1.2",
                    "scorm_2004": "SCORM 2004"
                },
                "result_mode": {
                    "status_only": "Solo lo stato",
                    "status_and_score": "Stato e punteggio",
                    "status_score_and_review": "Stato, punteggio e un link al riepilogo"
                },
                "warnings": {
                    "limited_mode": "Modalità limitata: il punteggio e l'esito non compariranno nel sistema di formazione, e la verifica dell'assegnazione non viene eseguita.",
                    "connection_disabled": "La connessione è disattivata: gli avvii tramite questa pubblicazione non vengono accettati affatto finché un amministratore non la riattiva.",
                    "assignment_check_off": "Con l'interruttore disattivato, una riassegnazione del corso non viene rilevata.",
                    "no_course_binding": "La pubblicazione non è collegata a un corso: il punteggio non arriverà al sistema di formazione."
                },
                "dialog": {
                    "connection_label": "Connessione",
                    "scenario_label": "Scenario",
                    "channel_label": "Canale di consegna",
                    "channel_hint": "Viene integrato nel pacchetto e non può più essere cambiato in seguito.",
                    "status_label": "Stato",
                    "status_hint": "Una pubblicazione non viene mai eliminata, ma disattivata. Dopodiché i nuovi avvii vengono rifiutati e i risultati non ancora inviati vengono annullati.",
                    "settings_section": "Impostazioni del tentativo",
                    "attempts_label": "Tentativi per discente",
                    "attempts_unlimited": "Senza limite",
                    "daily_budget_label": "Avvii al giorno per discente",
                    "daily_budget_hint": "Protegge la quota: ogni conversazione avviata viene scalata e non viene mai restituita.",
                    "result_mode_label": "Cosa viene trasmesso al sistema di formazione",
                    "pass_threshold_label": "Soglia di superamento, 0-100",
                    "result_wait_label": "Attesa della valutazione, in ore",
                    "result_wait_hint": "Trascorso questo tempo, l'avvio segnala «nessun risultato».",
                    "launch_limit_label": "Limite totale di avvii",
                    "launch_limit_hint": "Lasciare vuoto per nessun limite.",
                    "assignment_check_label": "Verificare l'assegnazione nel sistema di formazione",
                    "binding_section": "Collegamento nel sistema di formazione",
                    "external_course_label": "ID del corso",
                    "external_item_label": "ID dell'elemento",
                    "expires_label": "Scadenza della pubblicazione",
                    "expires_hint": "Lasciare vuoto se la pubblicazione non scade."
                },
                "key_dialog": {
                    "title": "La pubblicazione è stata creata",
                    "warning": "La chiave viene mostrata una sola volta e solo qui. Non potrà più essere riletta da nessuna parte: la copi ora e la inserisca nelle impostazioni del pacchetto. Se la perde, dovrà creare una nuova pubblicazione.",
                    "key_label": "Chiave di pubblicazione",
                    "copied": "Copiato",
                    "package_hint": "La chiave è già inclusa nel pacchetto, quindi non c'è nulla da incollare da nessuna parte. Scarichi il pacchetto e lo carichi nel sistema di formazione. Può scaricarlo di nuovo in qualsiasi momento dalla pagina Pubblicazioni."
                },
                "messages": {
                    "saved": "Pubblicazione salvata",
                    "enabled": "Pubblicazione attivata",
                    "disabled": "Pubblicazione disattivata",
                    "download_failed": "Impossibile scaricare il pacchetto. Ricarichi la pagina e riprovi."
                }
            },
            "journal": {
                "title": "Registro degli avvii",
                "unknown_scenario": "Scenario non disponibile",
                "back": "Alle pubblicazioni",
                "revoke": "Revoca il tentativo",
                "revoke_confirm": "Revocare questo tentativo? Il discente perderà l'accesso alla conversazione e gli invii non ancora andati a buon fine verranno annullati.",
                "retry_delivery": "Riprova",
                "empty_launches": "Nessun avvio per ora.",
                "empty_events": "Nessun evento per ora.",
                "no_deliveries": "Questo tentativo non ha invii.",
                "not_held_quota_charged": "Non svolta, quota scalata",
                "relaunches": "ritorni: {value}",
                "last_launch": "ultimo avvio: {value}",
                "result_deadline": "In attesa della valutazione fino al {value}",
                "learner_contacts": "Indirizzo inviato dal sistema di formazione: {email}. Avviato da: {ip}",
                "score_passed": "{value} — superato",
                "score_failed": "{value} — non superato",
                "tabs": {
                    "launches": "Tentativi",
                    "events": "Eventi"
                },
                "headers": {
                    "learner": "Discente",
                    "user": "Account",
                    "attempt": "Tentativo",
                    "status": "Stato",
                    "game": "Conversazione",
                    "started_at": "Avviato",
                    "actions": " ",
                    "event_type": "Evento",
                    "refusal": "Motivo",
                    "request_proof": "Prova della richiesta",
                    "ip": "Indirizzo",
                    "user_agent": "Client",
                    "happened_at": "Quando"
                },
                "launch_status": {
                    "created": "Link emesso",
                    "started": "In corso",
                    "not_held": "Non svolta",
                    "awaiting_result": "In attesa di valutazione",
                    "result_ready": "Risultato consegnato",
                    "evaluation_failed": "Nessuna valutazione",
                    "result_timed_out": "Tempo di attesa scaduto",
                    "assignment_changed": "Assegnazione modificata",
                    "revoked": "Revocato"
                },
                "delivery": {
                    "version": "Versione",
                    "status": "Stato",
                    "outcome": "Esito",
                    "result": "Risultato",
                    "score": "Punteggio",
                    "attempts": "Tentativi",
                    "last_attempt": "Ultimo tentativo",
                    "external_state": "Stato nel sistema di formazione"
                },
                "delivery_status": {
                    "pending": "In coda",
                    "in_progress": "Invio in corso",
                    "done": "Completato",
                    "needs_attention": "Richiede attenzione"
                },
                "delivery_outcome": {
                    "accepted": "Accettato",
                    "confirmed": "Confermato",
                    "rejected_by_external": "Rifiutato",
                    "retry": "Nuovo tentativo programmato",
                    "cancelled": "Annullato",
                    "assignment_changed": "Assegnazione modificata"
                },
                "result": {
                    "passed": "Superato",
                    "failed": "Non superato",
                    "not_held": "Non svolta",
                    "no_result": "Nessun risultato"
                },
                "refusal": {
                    "publication_disabled": "Pubblicazione disattivata",
                    "publication_draft": "Pubblicazione ancora bozza",
                    "publication_expired": "Pubblicazione scaduta",
                    "feature_disabled": "Avvio esterno disattivato",
                    "connection_disabled": "Connessione disattivata",
                    "launch_limit_reached": "Limite di avvii raggiunto",
                    "daily_budget_exhausted": "Budget giornaliero esaurito",
                    "attempts_exhausted": "Tentativi esauriti",
                    "quota_exhausted": "Quota dell'organizzazione esaurita",
                    "user_limit_reached": "Nessun posto libero",
                    "scenario_unavailable": "Scenario non disponibile",
                    "assignment_check_unavailable": "Verifica dell'assegnazione non disponibile",
                    "code_invalid": "Link già usato o scaduto",
                    "channel_verification_failed": "Il sistema di formazione non ha confermato la richiesta",
                    "external_system_unavailable": "Il sistema di formazione non ha risposto alla verifica dell'assegnazione",
                    "user_not_found": "Nessun account per questo discente",
                    "user_unavailable": "Account del discente disattivato",
                    "user_deleted": "Account del discente eliminato",
                    "email_taken_linking_disabled": "L'email appartiene a un altro account",
                    "service_role_not_allowed": "Un account di servizio non può fare pratica",
                    "unverified_request": "Richiesta non confermata"
                },
                "event_type": {
                    "launch_refused": "Avvio rifiutato",
                    "exchange_refused": "Link rifiutato",
                    "exchange_succeeded": "Link utilizzato"
                },
                "request_proof": {
                    "unverified": "Non confermata",
                    "assignment_verified": "Assegnazione confermata"
                },
                "messages": {
                    "retry_queued": "Nuovo tentativo in coda",
                    "revoked": "Tentativo revocato"
                }
            }
        }
    },
    "voiceSession": {
        "mode": {
            "training": "Allenamento",
            "interview": "Colloquio"
        },
        "load": {
            "loading": "Caricamento della sessione…",
            "failed": "Impossibile caricare la sessione. Controlli la connessione e riprovi.",
            "scenarioFailed": "Impossibile caricare lo scenario",
            "scenarioRetry": "Riprova"
        },
        "leave": {
            "confirm": "La conversazione è in corso. Uscire dalla pagina non la interrompe, e il tempo continua a scorrere. Uscire dalla pagina?",
            "confirmEnd": "La conversazione è in corso. Se esce, terminerà e sarà valutata in base a quanto sarà stato affrontato. Uscire?"
        },
        "elsewhere": {
            "interviewTitle": "Il colloquio è aperto in un'altra scheda",
            "interviewText": "Il colloquio è in corso in un'altra scheda o su un altro dispositivo. Lo continui lì — può chiudere questa scheda.",
            "conversationTitle": "La conversazione è aperta in un'altra scheda",
            "conversationText": "La conversazione è in corso in un'altra scheda o su un altro dispositivo. La continui lì — può chiudere questa scheda."
        },
        "prep": {
            "header": {
                "backToSessions": "Alle sessioni",
                "themeToggleAriaLabel": "Cambia tema"
            },
            "scenario": {
                "sectionLabel": "Scenario",
                "competenceLabel": "Competenza valutata",
                "gameNumber": "Sessione #{number}",
                "duration": "{minutes} min",
                "readFull": "Leggi tutto",
                "generalLabel": "Informazioni generali",
                "playerLabel": "Informazioni per lei"
            },
            "selfCamera": {
                "previewLabel": "Anteprima della sua telecamera",
                "off": "La telecamera è spenta"
            },
            "notes": {
                "empty": "Vuoto"
            },
            "start": {
                "button": "Inizia sessione",
                "interviewButton": "Inizia il colloquio",
                "resumeButton": "Torna alla conversazione",
                "resumeHint": "La conversazione è già in corso — il tempo continua a scorrere."
            }
        },
        "equipment": {
            "status": {
                "checking": "Verifica dei dispositivi",
                "waiting": "In attesa dell'autorizzazione",
                "denied": "Accesso negato",
                "busy": "Dispositivo occupato",
                "noCamera": "Nessuna telecamera",
                "missing": "Nessun microfono",
                "dismissed": "Accesso non concesso",
                "ready": "Dispositivi pronti"
            },
            "checking": {
                "title": "Verifica del microfono e della telecamera…"
            },
            "waiting": {
                "title": "Consenta l'accesso al microfono",
                "cameraTitle": "Consenta l'accesso alla telecamera",
                "description": "La richiesta di autorizzazione del browser è già aperta. Senza microfono la conversazione non può iniziare."
            },
            "denied": {
                "title": "Il browser blocca il microfono",
                "cameraTitle": "Il browser blocca la telecamera",
                "description": "Il browser ha memorizzato il blocco. Consenta l'accesso al microfono nelle impostazioni del sito e ricarichi la pagina.",
                "cameraDescription": "Il browser ha memorizzato il blocco. Consenta l'accesso alla telecamera nelle impostazioni del sito e ricarichi la pagina.",
                "showInstructions": "Come fare",
                "hideInstructions": "Nascondi",
                "chromeEdge": {
                    "browser": "Chrome ed Edge",
                    "text": "Faccia clic sull'icona del lucchetto a sinistra della barra degli indirizzi, apra «Impostazioni sito», consenta «Microfono» e ricarichi la pagina."
                },
                "safari": {
                    "browser": "Safari",
                    "text": "Apra il menu Safari → «Impostazioni per questo sito web», consenta «Microfono» e ricarichi la pagina."
                },
                "firefox": {
                    "browser": "Firefox",
                    "text": "Faccia clic sull'icona del microfono nella barra degli indirizzi, rimuova il blocco per questo sito e ricarichi la pagina."
                },
                "system": {
                    "title": "Il sistema impedisce al browser di accedere al microfono",
                    "cameraTitle": "Il sistema impedisce al browser di accedere alla telecamera",
                    "macos": "macOS: Impostazioni di Sistema → Privacy e sicurezza → Microfono (o Fotocamera) → attivi il browser e lo riavvii.",
                    "windows": "Windows: Impostazioni → Privacy e sicurezza → Microfono (o Fotocamera) → consenta l'accesso alle app e al browser, poi prema «Riprova»."
                }
            },
            "busy": {
                "title": "Il microfono è occupato da un'altra app",
                "cameraTitle": "La telecamera è utilizzata da un'altra app",
                "description": "Di solito è una chiamata rimasta aperta in background. La chiuda e prema «Riprova».",
                "retry": "Riprova"
            },
            "noCamera": {
                "title": "Nessuna telecamera",
                "description": "La sentiranno, ma non La vedranno.",
                "requiredByScenario": "Questa conversazione richiede una telecamera. Ne colleghi una per continuare."
            },
            "missing": {
                "title": "Nessun microfono trovato",
                "description": "Colleghi un microfono e prema «Riprova». Senza microfono la conversazione non può iniziare."
            },
            "dismissed": {
                "title": "L'accesso al microfono non è stato concesso",
                "cameraTitle": "L'accesso alla telecamera non è stato concesso",
                "description": "La finestra del browser è stata chiusa senza risposta. Prema «Riprova» e conceda l'accesso."
            },
            "ready": {
                "title": "Dispositivi pronti"
            },
            "micLabel": "Microfono",
            "cameraLabel": "Telecamera",
            "chooseMic": "Scegli il microfono",
            "chooseCamera": "Scegli la telecamera",
            "micLevelHint": "Dica qualcosa",
            "speakerValue": "Altoparlante: {name}",
            "configure": "Configura",
            "dialog": {
                "title": "Dispositivi",
                "lockedDuringConversation": "I dispositivi non possono essere modificati durante la conversazione.",
                "micSelectLabel": "Microfono",
                "cameraSelectLabel": "Telecamera",
                "speakerSelectLabel": "Altoparlante",
                "noCameraOption": "Nessuna telecamera",
                "record": "Registra 3 secondi",
                "recording": "Registrazione…",
                "recordFailed": "Impossibile registrare. Riprovi.",
                "listen": "Ascolta",
                "playing": "Riproduzione…",
                "done": "Fatto",
                "closeAriaLabel": "Chiudi la finestra di dialogo"
            },
            "unnamed": {
                "microphone": "Microfono {number}",
                "camera": "Telecamera {number}",
                "speaker": "Altoparlante {number}"
            },
            "cameraWarmup": {
                "preview": "La telecamera si sta accendendo",
                "title": "Microfono pronto",
                "description": "La telecamera si attiverà a breve — di solito ci vuole un secondo o due.",
                "slowHint": "La telecamera non si accende? Ne scelga un'altra con «Configura»."
            }
        },
        "recording": {
            "videoAndAudio": "La conversazione e il video vengono registrati.",
            "audioOnly": "La conversazione viene registrata.",
            "accessSelfAndEvaluators": "La registrazione è disponibile per Lei e per chi valuta il Suo lavoro.",
            "accessEvaluators": "La registrazione è disponibile per chi valuta il Suo lavoro."
        },
        "scenario": {
            "video": "Video dell'autore dello scenario"
        },
        "notes": {
            "title": "Note della sessione",
            "placeholder": "Cosa desidera esercitare, formulazioni che ha preparato",
            "saving": "Salvataggio…",
            "saved": "Salvato",
            "saveError": "Impossibile salvare",
            "visibility": "Le note sono visibili a Lei e a chi valuta la sessione.",
            "unsupported": "Queste note contengono elementi che non possono essere modificati qui. Restano invariate."
        },
        "stage": {
            "agentState": {
                "speaking": "Parla",
                "listening": "Ascolta",
                "thinking": "Pensa"
            },
            "micOffWarning": "Il microfono è spento — l'interlocutore non può sentirLa",
            "micOnAriaLabel": "Disattiva il microfono",
            "micOffAriaLabel": "Attiva il microfono",
            "micOff": "Microfono disattivato",
            "micOnAnnouncement": "Microfono attivato",
            "captionsLabel": "Sottotitoli",
            "captionsOnAriaLabel": "Nascondi i sottotitoli",
            "captionsOffAriaLabel": "Mostra i sottotitoli",
            "talkBalance": {
                "title": "Equilibrio del parlato",
                "you": "Lei",
                "interlocutor": "Interlocutore"
            },
            "connectionQuality": {
                "excellent": "Connessione eccellente",
                "good": "Buona connessione",
                "poor": "Connessione debole",
                "unknown": "Qualità della connessione sconosciuta"
            },
            "selfCameraLabel": "Lei",
            "timeWarning": {
                "lastMinute": "Resta un minuto — è ora di concludere",
                "finalSeconds": "15 secondi — concluda il Suo pensiero"
            },
            "timeUp": {
                "title": "Il tempo è scaduto",
                "text": "La conversazione si concluderà da sola; non può essere prolungata.",
                "closing": "Chiusura della conversazione…"
            },
            "voiceOnly": "Modalità vocale — questo scenario non ha un video",
            "interlocutorConnecting": {
                "title": "Interlocutore in connessione",
                "hint": "Di solito 2–4 secondi"
            },
            "layout": {
                "label": "Affiancati",
                "sideTitle": "Disponi affiancati",
                "focusTitle": "Interlocutore in grande"
            }
        },
        "panels": {
            "scenario": "Scenario",
            "transcript": "Trascrizione",
            "transcriptEmpty": "Le risposte completate appariranno qui.",
            "notes": "Note",
            "characterMemoryTab": "Cosa ricorda il personaggio",
            "openAriaLabel": "Apri il pannello «{panel}»",
            "closeAriaLabel": "Chiudi il pannello «{panel}»"
        },
        "sound": {
            "label": "Audio",
            "volumeLabel": "Volume",
            "speakerLabel": "Altoparlante"
        },
        "end": {
            "button": "Termina",
            "confirmTitle": "Terminare la conversazione?",
            "elapsed": "Tempo trascorso: {elapsed} di {total}.",
            "partialEvaluationNotice": "La conversazione sarà valutata in base a quanto sarà stato affrontato.",
            "continue": "Continua",
            "notSent": "La conversazione terminerà allo scadere del tempo: il server non ha risposto alla richiesta di terminare."
        },
        "wait": {
            "title": "Preparazione della conversazione",
            "hint": "Di solito ci vogliono 1–3 minuti. Non chiuda la pagina — inizieremo automaticamente.",
            "nextTry": "Prossimo tentativo tra {time}",
            "trying": "Tentativo di avvio…",
            "retrying": "Non ancora. Nuovo tentativo tra {time}",
            "cancel": "Annulla",
            "failed": {
                "title": "Impossibile avviare la conversazione",
                "text": "Al momento non ci sono posti liberi. Le impostazioni di microfono e fotocamera sono salvate — riprovi tra un paio di minuti.",
                "retry": "Riprova"
            }
        },
        "connection": {
            "reconnecting": "Connessione persa, riconnessione in corso…",
            "restored": "Connessione ripristinata",
            "failed": "Impossibile ripristinare la connessione",
            "retry": "Riprova"
        },
        "hotkeys": {
            "title": "Scorciatoie da tastiera",
            "showHintAriaLabel": "Mostra le scorciatoie da tastiera",
            "micToggle": "Attiva/disattiva il microfono",
            "scenarioPanel": "Scenario: apri e chiudi il pannello",
            "transcriptPanel": "Trascrizione",
            "notesPanel": "Note",
            "captionsToggle": "Attiva/disattiva i sottotitoli",
            "closeTopLayer": "Chiudi pannello, popover o finestra di dialogo",
            "endConfirm": "Termina — apre la conferma",
            "showHint": "Mostra questo suggerimento"
        },
        "intro": {
            "candidate": {
                "greeting": "Salve, {name}!",
                "leadWithVacancy": "{organization} La invita a un colloquio con un interlocutore virtuale per il ruolo di «{vacancy}».",
                "duration": "Il colloquio dura circa {minutes} min.",
                "requirementsTitle": "Cosa Le servirà",
                "requirementMic": "Un microfono funzionante, idealmente delle cuffie con microfono",
                "requirementCameraRequired": "Telecamera accesa: per questo colloquio è obbligatoria",
                "requirementCameraOptional": "La telecamera non è obbligatoria, ma rende la conversazione più naturale",
                "requirementBrowser": "Un computer con una versione aggiornata di Chrome, Edge o Safari",
                "requirementNetwork": "Una connessione stabile e un luogo tranquillo dove nessuno La interromperà",
                "consentTextLabel": "Testo del consenso",
                "consentAccept": "Ho letto il testo e acconsento al trattamento dei miei dati personali",
                "next": "Avanti"
            },
            "launch": {
                "title": "Conversazione di pratica",
                "lead": "Sta per parlare con un interlocutore virtuale. La conversazione viene registrata e valutata, e il risultato tornerà al suo sistema di formazione.",
                "requirementsTitle": "Cosa Le servirà",
                "requirementMic": "Un microfono funzionante, idealmente delle cuffie con microfono",
                "requirementCamera": "La telecamera non è obbligatoria, ma rende la conversazione più vivace",
                "requirementBrowser": "Un computer con una versione aggiornata di Chrome, Edge o Safari",
                "requirementNetwork": "Una connessione stabile e un luogo tranquillo dove nessuno La interromperà",
                "start": "Inizia"
            }
        },
        "finished": {
            "candidate": {
                "title": "Grazie!",
                "text": "Il colloquio è terminato. Il risultato sarà inviato al recruiter, che La contatterà. Può chiudere questa pagina."
            },
            "launch": {
                "title": "Grazie!",
                "text": "La conversazione è terminata. Il risultato comparirà nel suo sistema di formazione quando la valutazione sarà pronta. Può chiudere questa pagina."
            }
        },
        "closeDialogAriaLabel": "Chiudi la finestra di dialogo"
    },
    "loopAvatars": {
        "title": "Avatar in loop",
        "upload": "Carica avatar",
        "newVersion": "Nuova versione",
        "newVersionHint": "“{name}”, versione attuale {version}. Il nuovo pacchetto sostituisce i video in tutti i profili con questo avatar.",
        "edit": "Modifica avatar",
        "delete": "Elimina avatar",
        "empty": "Ancora nessun avatar",
        "headers": {
            "poster": "Anteprima",
            "name": "Nome",
            "gender": "Genere",
            "emotion": "Emozione",
            "visibility": "Visibilità",
            "version": "Versione",
            "profiles": "Profili"
        },
        "gender": {
            "male": "Maschile",
            "female": "Femminile"
        },
        "emotion": {
            "calm": "Calmo",
            "friendly": "Amichevole",
            "strict": "Severo"
        },
        "visibility": {
            "all": "Tutte le organizzazioni"
        },
        "fields": {
            "package": "Pacchetto avatar (.zip)"
        },
        "packageHint": "ZIP fino a 100 MB con manifest.json, listen.mp4, talk.mp4, transitions.json e poster.jpg",
        "validation": {
            "packageTooLarge": "Il pacchetto non deve superare i 100 MB"
        },
        "errors": {
            "requestFailed": "Richiesta non riuscita. Riprova."
        },
        "confirmDetach": "Profili da scollegare: {count}. Passeranno alla foto. Salvare?",
        "confirmDelete": "Eliminare l'avatar “{name}”?",
        "confirmDeleteWithProfiles": "L'avatar “{name}” è usato nei profili: {count}. Passeranno alla foto. Eliminare?"
    },
    "ttsVoices": {
        "title": "Voci TTS",
        "create": "Aggiungi voce",
        "edit": "Modifica voce",
        "delete": "Elimina voce",
        "replaceSample": "Sostituisci campione",
        "replaceSampleHint": "“{name}”, versione attuale del campione {version}. Il nuovo campione verrà usato in tutti i profili con questa voce.",
        "empty": "Ancora nessuna voce",
        "play": "Ascolta il campione",
        "stop": "Interrompi",
        "headers": {
            "name": "Nome",
            "provider": "Provider",
            "externalId": "ID voce",
            "gender": "Genere",
            "languages": "Lingue",
            "visibility": "Visibilità",
            "sample": "Campione",
            "profiles": "Profili"
        },
        "gender": {
            "male": "Maschile",
            "female": "Femminile"
        },
        "visibility": {
            "all": "Tutte le organizzazioni"
        },
        "fields": {
            "sample": "Campione della voce",
            "speed": "Velocità del parlato"
        },
        "sampleHint": "MP3, MP4 o M4A fino a 5 MB",
        "sampleOptionalHint": "Facoltativo — il campione verrà generato con la voce tramite il suo ID. MP3, MP4 o M4A fino a 5 MB",
        "synthesizeSample": "Genera di nuovo",
        "speedChangedHint": "Genera di nuovo il campione della voce per ascoltare la nuova velocità.",
        "speedSamplePromptTitle": "Velocità modificata",
        "speedSamplePrompt": "Il campione suona ancora alla velocità precedente. Generarlo di nuovo? Il campione attuale verrà sostituito.",
        "saveAndSynthesize": "Salva e genera",
        "saveOnly": "Salva solo",
        "validation": {
            "sampleTooLarge": "Il campione non deve superare i 5 MB"
        },
        "errors": {
            "requestFailed": "Richiesta non riuscita. Riprova.",
            "sampleUnavailable": "Impossibile riprodurre il campione"
        },
        "confirmDetach": "Profili da scollegare: {count}. Passeranno alla voce del connettore. Salvare?",
        "confirmDelete": "Eliminare la voce “{name}”?",
        "confirmDeleteWithProfiles": "La voce “{name}” è usata nei profili: {count}. Passeranno alla voce del connettore. Eliminare?",
        "picker": {
            "none": "Voce predefinita",
            "empty": "Nessuna voce di questo genere nel catalogo",
            "loadError": "Impossibile caricare le voci",
            "playSample": "Ascolta il campione: {name}",
            "stopSample": "Interrompi il campione: {name}",
            "sampleUnavailable": "Campione non disponibile"
        }
    },
    "realtimeAvatars": {
        "title": "Avatar Live",
        "create": "Aggiungi avatar",
        "edit": "Modifica avatar",
        "delete": "Elimina avatar",
        "preview": "Guarda l'anteprima",
        "empty": "Ancora nessun avatar",
        "headers": {
            "poster": "Copertina",
            "name": "Nome",
            "provider": "Provider",
            "externalId": "ID avatar",
            "gender": "Genere",
            "visibility": "Visibilità",
            "profiles": "Profili",
            "models": "Modelli Anam"
        },
        "gender": {
            "male": "Maschile",
            "female": "Femminile"
        },
        "visibility": {
            "all": "Tutte le organizzazioni"
        },
        "nameHint": "Facoltativo — verrà usato il nome di Anam",
        "externalIdHint": "Se cambi l'ID, la copertina e l'anteprima vengono caricate di nuovo da Anam",
        "errors": {
            "requestFailed": "Richiesta non riuscita. Riprova.",
            "previewUnavailable": "Impossibile riprodurre l'anteprima"
        },
        "confirmDetach": "Profili da scollegare: {count}. Passeranno alla foto. Salvare?",
        "confirmDelete": "Eliminare l'avatar “{name}”?",
        "confirmDeleteWithProfiles": "L'avatar “{name}” è usato nei profili: {count}. Passeranno alla foto. Eliminare?",
        "picker": {
            "label": "Avatar Live",
            "empty": "Nessun avatar Live disponibile per questo profilo",
            "emptyFiltered": "Nessun avatar Live di questo genere",
            "loadError": "Impossibile caricare gli avatar Live"
        }
    },
    "aiProfileAppearance": {
        "label": "Aspetto",
        "photo": "Foto personale",
        "avatar": "Studio",
        "live": "Live",
        "mascot": "Mascotte",
        "filterGender": "Genere",
        "filterEmotion": "Emozione",
        "avatarsLabel": "Avatar",
        "avatarRequired": "Scegli un avatar",
        "liveRequired": "Scegli un avatar Live",
        "livePlaceholder": "Il tuo avatar Live apparirà qui",
        "empty": "Nessun avatar disponibile per questo profilo",
        "emptyFiltered": "Nessun avatar corrisponde ai filtri",
        "loadError": "Impossibile caricare gli avatar",
        "playPreview": "Riproduci anteprima: {name}",
        "pausePreview": "Metti in pausa l'anteprima: {name}"
    },
  "emailStopList": {
    "title": "Lista di blocco email",
    "description": "Le email a questi indirizzi e domini non vengono inviate. Una voce di dominio copre tutti gli indirizzi di quel dominio, ma non i suoi sottodomini.",
    "searchPlaceholder": "Cerca per indirizzo o dominio",
    "allReasons": "Tutti i motivi",
    "add": "Aggiungi",
    "addTitle": "Blocca un indirizzo o un dominio",
    "empty": "La lista di blocco è vuota",
    "editNote": "Modifica nota",
    "headers": {
      "type": "Tipo",
      "value": "Indirizzo o dominio",
      "reason": "Motivo",
      "providerReply": "Risposta del servizio di posta",
      "note": "Nota",
      "author": "Aggiunto da",
      "createdAt": "Data di aggiunta",
      "blockedCount": "Email bloccate",
      "lastBlockedAt": "Ultimo blocco"
    },
    "type": {
      "address": "Indirizzo",
      "domain": "Dominio"
    },
    "reason": {
      "manual": "Manuale",
      "providerRejected": "Rifiutato dal servizio di posta"
    },
    "author": {
      "system": "Sistema"
    },
    "fields": {
      "value": "Indirizzo o dominio",
      "valueHint": "Inserisci un indirizzo completo o solo un dominio. Un dominio blocca tutti i suoi indirizzi, ma non i sottodomini.",
      "note": "Nota"
    },
    "errors": {
      "requestFailed": "Qualcosa è andato storto. Riprova."
    },
    "unblock": {
      "action": "Sblocca",
      "confirm": "Sbloccare {value}?",
      "resultTitle": "Esito dello sblocco",
      "result": {
        "removedEverywhere": "Sbloccato. Il servizio di posta non ha questo indirizzo nella sua lista di blocco, quindi le email verranno di nuovo inviate.",
        "removedLocally": "Dominio sbloccato. Gli indirizzi di questo dominio che hanno una propria voce restano bloccati.",
        "providerNotConfigured": "È stata rimossa solo la voce della piattaforma: la connessione al servizio di posta non è configurata, quindi la sua lista di blocco non è stata controllata.",
        "providerUnavailable": "Il servizio di posta non è disponibile, riprova più tardi. L'indirizzo resta bloccato.",
        "stillListedAtProvider": "L'indirizzo è nella lista di blocco del servizio di posta. Rimuovilo nel pannello del servizio e fai clic su «Sblocca di nuovo». Se il pannello non mostra l'indirizzo, si trova nella lista di blocco globale del servizio e da lì non può essere rimosso."
      },
      "openPanel": "Apri il pannello del servizio di posta",
      "panelPath": "Dove rimuoverlo: pannello del servizio di posta → Products → Email Service → la tua risorsa → scheda Stop Lists.",
      "retry": "Sblocca di nuovo"
    },
    "suggestions": {
      "text": "Il dominio {domain} ha {count} indirizzi bloccati. Bloccare l'intero dominio?",
      "block": "Blocca dominio",
      "confirm": "Bloccare il dominio {domain}? Le email a tutti i suoi indirizzi non verranno più inviate. I sottodomini non sono interessati e le voci dei singoli indirizzi restano."
    },
    "check": {
      "title": "Controlla un indirizzo",
      "hint": "Mostra se le email all'indirizzo sono bloccate dalla piattaforma o dal servizio di posta",
      "placeholder": "Indirizzo email",
      "submit": "Controlla",
      "resultFor": "Risultato per {email}",
      "platform": "Lista di blocco della piattaforma",
      "platformListed": "Sì — voce «{value}»",
      "provider": "Lista di blocco del servizio di posta",
      "listed": "Sì",
      "notListed": "No",
      "providerReasons": "Motivi indicati dal servizio di posta:",
      "providerNotConfigured": "La connessione al servizio di posta non è configurata",
      "providerUnavailable": "Il servizio di posta non è disponibile, riprova più tardi"
    }
  }
}
